// src/components/GroupSettings.tsx
import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useSocket } from "../context/SocketProvider";

import * as Style from "../styles/GroupSettings.style";
import { MediaQuery } from 'react-responsive';

import { Modal } from 'antd';

import ModeSelectionModal from './GroupSettingModeSelectModal'
import TimeBrightModal from './GroupSettingTimeBrightModal'
import TimeModal from './GroupSettingTimeModal'
import ConfirmButtonModal from './ConfirmButtonModal'

// Common 아이콘
import MenuLedIcon from '../imgs/ic_menu_led_default.svg';
import MenuResetIcon from '../imgs/ic_menu_reset_default.svg';
import MenuMotionIcon from '../imgs/ic_menu_motion_default.svg';
import MenuSensorIcon from '../imgs/ic_menu_sensor_default.svg';
import MenuMonthlyIcon from '../imgs/ic_menu_monthly_default.svg';

// Mobile 아이콘
import MenuLedSelectIcon from '../imgs/mobile/ic_mobile_menu_led_selected.svg';
import MenuResetSelectIcon from '../imgs/mobile/ic_mobile_menu_reset_selected.svg';
import MenuMotionSelectIcon from '../imgs/mobile/ic_mobile_menu_motion_selected.svg';
import MenuSensorSelectIcon from '../imgs/mobile/ic_mobile_menu_sensor_selected.svg';
import MenuMonthlySelectIcon from '../imgs/mobile/ic_mobile_menu_monthly_selected.svg';

// Tablet 아이콘
import MenuLedSelectTabletIcon from '../imgs/tablet/ic_tablet_menu_led_selected.svg';
import MenuResetSelectTabletIcon from '../imgs/tablet/ic_tablet_menu_reset_selected.svg';
import MenuMotionSelectTabletIcon from '../imgs/tablet/ic_tablet_menu_motion_selected.svg';
import MenuSensorSelectTabletIcon from '../imgs/tablet/ic_tablet_menu_sensor_selected.svg';
import MenuMonthlySelectTabletIcon from '../imgs/tablet/ic_tablet_menu_monthly_selected.svg';

import MenuMotionArrowDownFocusTabletIcon from '../imgs/tablet/ic_tablet_arrow_down_selected.svg';
import MenuMotionArrowDownTabletIcon from '../imgs/tablet/ic_tablet_arrow_down.svg';

import MenuMonthlyMinusTabletIcon from '../imgs/ic_minus_tablet.svg';
import MenuMonthlyPlusTabletIcon from '../imgs/ic_plus_tablet.svg';

import CursorSVG from '../imgs/cursor.svg'; 


//const SOCKET_URL = "http://172.16.20.112:3000"; // socket.io 서버
const SOCKET_URL = "https://rek-hybrid.co.kr"; // socket.io 서버

interface UserData {
    role: string;
    // 필요한 다른 속성들...
}

const ledButtons = [
    { label: 'On', value: 1 },
    { label: 'Off', value: 0 },
    { label: 'Blink', value: 2 },
];

interface IconComponents {
  [key: number]: { default: string; selected: string; }; // 💡 키가 숫자(number)여도 string 값을 가진다는 것을 명시
}
const iconComponents: IconComponents = {
    1: {
        default: MenuLedIcon,    // 기본 아이콘 (예: 회색)
        selected: MenuLedSelectIcon,  // 선택된 아이콘 (예: 파란색)
    },
    2: {
        default: MenuResetIcon,    // 기본 아이콘 (예: 회색)
        selected: MenuResetSelectIcon,  // 선택된 아이콘 (예: 파란색)
    },
    3: {
        default: MenuMotionIcon,    // 기본 아이콘 (예: 회색)
        selected: MenuMotionSelectIcon,    // 기본 아이콘 (예: 회색)
        // selected: '../imgs/ic_menu_motion_selected.svg',  // 선택된 아이콘 (예: 파란색)
    },
    4: {
        default: MenuSensorIcon,    // 기본 아이콘 (예: 회색)
        selected: MenuSensorSelectIcon,    // 기본 아이콘 (예: 회색)
        // selected: '../imgs/ic_menu_sensor_selected.svg',  // 선택된 아이콘 (예: 파란색)
    },
    5: {
        default: MenuMonthlyIcon,    // 기본 아이콘 (예: 회색)
        selected: MenuMonthlySelectIcon,    // 기본 아이콘 (예: 회색)
        // selected: '../imgs/ic_menu_monthly_selected.svg',  // 선택된 아이콘 (예: 파란색)
    },
    // 1: MenuLedIcon,
    // 2: MenuResetIcon,
    // 3: MenuMotionIcon,
    // 4: MenuSensorIcon,
    // 5: MenuMonthlyIcon,
};

interface MenuTexts {
  [key: number]: string; // 💡 키가 숫자(number)여도 string 값을 가진다는 것을 명시
}

const menuTexts: MenuTexts = {
    1: 'LED제어 | 테스트',
    2: '디바이스 | 리셋',
    3: '감지센서 | 설정',
    4: 'LED | 동작모드',
    5: '월별밝기 | 설정'
    // ... 탭이 추가될 경우 여기에 계속 추가
};

const menuIds = [1, 2, 3, 4, 5];


interface Device {
  [k: string]: any;
}

//*********************************/
type TimeValue = { time: string; value: number };

const MAX_ROWS = 10;
const MONTHS = 12;
/**********************************/

interface Props {
    onfetchDeviceInfo: () => Promise<void>;

    currentUser: UserData | null;
    // 디바이스 정보
    devices: Device[];

    groupSettingTab: number;
    setGroupSettingTab: (n: number) => void;

    selectedGroupId: number | null;
    selectedSiteId: number | null;
    // Tab 1
    brightness: number;
    setBrightness: (v: number) => void;
    brightnessMode: number;
    setBrightnessMode: (v: number) => void;
    // Tab 3
    distanceLeft: number;
    setDistanceLeft: (v: number) => void;
    distanceRight: number;
    setDistanceRight: (v: number) => void;
    distanceBottom: number;
    setDistanceBottom: (v: number) => void;
    // Tab 4
    led_mode: number;
    setLed_mode: (v: number) => void;
    maxBright: number;
    setMaxBright: (v: number) => void;
    minBright: number;
    setMinBright: (v: number) => void;
    keepOnTime: number;
    setKeepOnTime: (v: number) => void;
    sideOnLed: number;
    setSideOnLed: (v: number) => void;
    // Tab 5
    activeMonthTab: number;
    setActiveMonthTab: (v: number) => void;
    nowMonth: number;
    setnowMonth: (v: number) => void;
    mValues: Record<string, MSlot[]>;
    setMValues: React.Dispatch<React.SetStateAction<Record<string, MSlot[]>>>;
}

type MSlot = { time: number; bright: number; is_active: boolean };



const GroupSettings: React.FC<Props> = ({
    onfetchDeviceInfo,
    currentUser,
    devices,

    groupSettingTab,
    setGroupSettingTab,

    selectedGroupId,
    selectedSiteId,
    // Tab 1
    brightness,
    setBrightness,
    brightnessMode,
    setBrightnessMode,
    // Tab 3
    distanceLeft,//: initialDistance,
    setDistanceLeft,
    distanceRight,
    setDistanceRight,
    distanceBottom,
    setDistanceBottom,
    // Tab 4
    led_mode,
    setLed_mode,
    maxBright,
    setMaxBright,
    minBright,
    setMinBright,
    keepOnTime,
    setKeepOnTime,
    sideOnLed,
    setSideOnLed,
    // Tab 5
    activeMonthTab,
    setActiveMonthTab,
    nowMonth,
    setnowMonth,
    mValues,
    setMValues,
}) => {

    const socket = useSocket();

    const [devicesDB, setDevicesDB] = useState< any[]>([]);

    const fetchDeviceSetInfo = async () => {
        if (!selectedSiteId || !selectedGroupId) return;
        try {
            const response = await axios.get(`${SOCKET_URL}/api/device/setinfo`, {
            params: { selectedSiteId, selectedGroupId },
            });

            if(response.data === null || response.data === '')
            {
                console.log('[DEBUG] React: 조회 값 없음');
            }
            else
            {
                //console.log('[DEBUG] React: 조회 응답', response.data);
                setDevicesDB(response.data.data);
            }
        } catch (error) {
            console.error('[DEBUG] React: API 호출 실패', error);
        }
    }; 

    
    // ***************************************************************************
    //    DB 설정 값으로 초기화, 저장 적용 테스트
    // ***************************************************************************
    let initDistanceLeft=0;
    let initDistanceRight=0;
    let initDistanceBottom=0;

    let initLedmode=0;
    let initMinBright=0;
    let initMaxBright=0;
    let initKeepOnTime=0;
    let initSideOnLed=0;
    // fetchDeviceSetInfo();
    // console.log("fetch setinfo ==> ",devicesDB[0].LDistS);

    // 💡 핵심: Prop으로 받은 초기값을 내부 상태의 초기값으로 설정
    // if (!devices || devices.length === 0)
    if (!devicesDB)    
    {

    }
    else
    {
        // initDistanceLeft = devicesDB[0].LDistS; //LDistS
        // initDistanceRight = devicesDB[0].RDistS; //RDistS
        // initDistanceBottom = devicesDB[0].DDistS; //DDistS

        // initLedmode = devicesDB[0].led_mode;
        // initMinBright = devicesDB[0].minLED;
        // initMaxBright = devicesDB[0].maxLED;
        // initKeepOnTime = devicesDB[0].LEDOnT;
        // initSideOnLed = devicesDB[0].sLEDN;
    }
    const [currentDistanceLeft, setCurrentDistanceLeft] = useState(initDistanceLeft);
    const [currentDistanceRight, setCurrentDistanceRight] = useState(initDistanceRight);
    const [currentDistanceBottom, setCurrentDistanceBottom] = useState(initDistanceBottom);

    const [currentLedmode, setCurrentLedmode] = useState(initLedmode);
    const [currentMinBright, setCurrentMinBright] = useState(initMinBright);
    const [currentMaxBright, setCurrentMaxBright] = useState(initMaxBright);
    const [currentKeepOnTime, setCurrentKeepOnTime] = useState(initKeepOnTime);
    const [currentSideOnLed, setCurrentSideOnLed] = useState(initSideOnLed);

    // 2. 탭 진입 시 (groupSettingTab이 변경될 때) 데이터 로드 (추가/수정)
    useEffect(() => {
        // 예를 들어, 해당 설정 탭이 '1'번 탭이라고 가정합니다.
        // if (groupSettingTab === 1) { // 특정 탭에 한정하고 싶다면 이 조건문을 사용합니다.
            fetchDeviceSetInfo();
        // }
    // 탭 상태와 API 호출에 필요한 의존성을 포함합니다.
    }, [groupSettingTab, selectedSiteId, selectedGroupId]);

    // 3. devicesDB 데이터가 로드되면 개별 상태 변수 초기화 (추가)
    useEffect(() => {
        if (devicesDB && devicesDB.length > 0) {
            const initialData = devicesDB[0]; // 배열의 첫 번째 장치 객체 (단일 설정 객체)

            // DB에서 가져온 값으로 개별 상태 변수를 초기화합니다.
            // 데이터가 undefined인 경우를 대비해 기본값( || 0)을 넣어주는 것이 좋습니다.
            setCurrentLedmode(initialData.led_mode ?? 0);
            setCurrentMaxBright(initialData.maxLED ?? 0);
            setCurrentMinBright(initialData.minLED ?? 0);
            setCurrentKeepOnTime(initialData.LEDOnT ?? 0);
            setCurrentSideOnLed(initialData.sLEDN ?? 0);
            setCurrentDistanceLeft(initialData.LDistS ?? [0, 0]);
            setCurrentDistanceRight(initialData.RDistS ?? [0, 0]);
            setCurrentDistanceBottom(initialData.DDistS ?? [0, 0]);

            const formattedOnTime = minutesToHHMM(initialData.OnT ?? 0);
            setSelectedModeOnTime(formattedOnTime);
            const formattedOffTime = minutesToHHMM(initialData.OffT ?? 0);
            setSelectedModeOffTime(formattedOffTime);

            //console.log('[DEBUG] React: 개별 상태 변수 초기화 완료', initialData);
        }
    }, [devicesDB]); // devicesDB가 변경될 때마다 실행

    // 내부 상태도 동기화
    // useEffect(() => {
    //     fetchDeviceSetInfo();

    //     setCurrentDistanceLeft(initDistanceLeft);
    //     setCurrentDistanceRight(initDistanceRight);
    //     setCurrentDistanceBottom(initDistanceBottom);

    //     setCurrentLedmode(Number(initLedmode)+1);
    //     setCurrentMinBright(initMinBright);
    //     setCurrentMaxBright(initMaxBright);
    //     setCurrentKeepOnTime(initKeepOnTime);
    //     setCurrentSideOnLed(initSideOnLed);

    // }, []);

    // 변경 핸들러 함수
    const handleDistanceLeftChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = Number(e.target.value);
        setCurrentDistanceLeft(newValue);        
        // onDistanceChange && onDistanceChange(newValue); // Prop이 있다면 부모에게 값 전달
    };
    const handleDistanceRightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = Number(e.target.value);
        setCurrentDistanceRight(newValue);        
        // onDistanceChange && onDistanceChange(newValue); // Prop이 있다면 부모에게 값 전달
    };
    const handleDistanceBottomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = Number(e.target.value);
        setCurrentDistanceBottom(newValue);        
        // onDistanceChange && onDistanceChange(newValue); // Prop이 있다면 부모에게 값 전달
    };    
    
    const saveDistancehData = async (left: number, right: number, bottom: number) => {
        if (!selectedSiteId || !selectedGroupId) return;

        // 1. 엔드포인트 URL 구성
        // URL에는 식별자만 포함: /api/device/setdistance/siteId/groupId
        const url = `${SOCKET_URL}/api/device/setdistance/${selectedSiteId}/${selectedGroupId}`;

        // 2. 요청 본문(Body) 데이터 구성
        // NestJS DTO 필드명에 맞춥니다.
        const requestBody = {
            distance_sensor_left: left, // mode
            distance_sensor_right: right, // min -> LED_min_luminosity
            distance_sensor_down: bottom, // max -> LED_max_luminosity
        };
        
        try {
            // 3. Axios PUT 요청
            const response = await axios.put(url, requestBody);
            
            //console.log('업데이트 성공:', response.data);
            return response.data;
            
        } catch (error) {
            console.error("업데이트 실패:", error);
            throw error; // 에러 처리를 위해 throw
        }

    };

    // ***************************************************************************

    // 👇 모션 모드 선택 모달 표시 여부 상태 추가
    const [isModeModalOpen, setIsModeModalOpen] = useState(false);
    // 👇 모션 모드 모달 열기/닫기 핸들러
    const openModeModal = () => setIsModeModalOpen(true);
    const closeModeModal = () => setIsModeModalOpen(false);

    const handleModeSelect = (modeValue: number) => {
        setCurrentLedmode(modeValue); // led_mode 상태 업데이트
        closeModeModal();          // 모달 닫기
    };

    // DB 저장
    const saveLedModehData = async (mode: number, min: number, max: number, onKeep:number, onValue:number, onTime:number, offTime:number) => {
        if (!selectedSiteId || !selectedGroupId) return;

        // 1. 엔드포인트 URL 구성
        // URL에는 식별자만 포함: /api/device/setmode/siteId/groupId
        const url = `${SOCKET_URL}/api/device/setmode/${selectedSiteId}/${selectedGroupId}`;

        // 2. 요청 본문(Body) 데이터 구성
        // NestJS DTO 필드명에 맞춥니다.
        const requestBody = {
            mode: mode, // mode
            LED_min_luminosity: min, // min -> LED_min_luminosity
            LED_max_luminosity: max, // max -> LED_max_luminosity
            LED_on_time: onKeep, // onKeep -> LED_on_time
            side_led_on_dev_num: onValue, // onValue -> side_led_on_dev_num
            mode_on_time: onTime,
            mode_off_time: offTime,
        };
        
        try {
            // 3. Axios PUT 요청
            const response = await axios.put(url, requestBody);
            
            //console.log('업데이트 성공:', response.data);
            return response.data;
            
        } catch (error) {
            console.error("업데이트 실패:", error);
            // console.error('업데이트 실패:', error.response ? error.response.data : error.message);
            throw error; // 에러 처리를 위해 throw
        }

    };


    // 👇 적용 확인 버튼 모달 표시 여부
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

    const openConfirmModal = () => setIsConfirmModalOpen(true);
    const closeConfirmModal = () => setIsConfirmModalOpen(false);    



    // ***************************************************************************
    // ***************************************************************************
    // ***************************************************************************


    // ***************************************************************************
    //    월별 시간 설정 관련
    // ***************************************************************************


    interface LineData {
        time: string;
        brightness: number;
    }    

    const [monthDataX, setMonthDataX] = useState<{ [key: number]: LineData[] }>(() =>
        Object.fromEntries(
        Array.from({ length: 12 }, (_, i) => [i + 1, [{ time: "00:00", brightness: 0 }]])
        )
    );    

    // const [modalOpen, setModalOpen] = useState(false);
    // const [editingIndex, setEditingIndex] = useState<number | null>(null);

    const [editingDefaultTime, setEditingDefaultTime] = useState<string>("00:00");
    const [editingDefaultBrightness, setEditingDefaultBrightness] = useState<number>(0);

    const currentMonthKey = `${activeMonthTab}M`;
    const currentSlots = mValues[currentMonthKey] || Array.from({ length: 10 }, () => ({
        time: 0,
        bright: 0,
        is_active: false,
    }));

    // const handleOpenModal = (index: number) => {
    //     const item = monthData[nowMonth]?.[index];
    //     if (!item) return; // 방어코드
    //     setEditingIndex(index);
    //     // setEditingDefaultTime(item.time);
    //     // setEditingDefaultBrightness(item.brightness);
    //     setModalOpen(true);
    // };

    // here
    // 💡 수정: mValues를 기반으로 모달을 여는 함수로 변경
    // const handleOpenModal = (index: number, defaultTime: string, defaultBrightness: number) => {
    //     // 이미 currentSlots에 데이터가 있으므로 바로 index와 모달 상태를 설정합니다.
    //     setEditingIndex(index);
    //     setModalOpen(true);
    // };    
    // here
    /**
     * @description 모달을 열고, 활성 슬롯 인덱스를 실제 인덱스로 변환하여 저장
     * @param activeIndex currentActiveSlots에서의 순서 (0, 1, 2, ...)
     */
    // const handleOpenModal = (activeIndex: number) => {
    //     const actualIndex = getActualIndex(activeIndex);
    //     if (actualIndex !== undefined) {
    //         setEditingIndex(actualIndex);
    //         setModalOpen(true);
    //     }
    // };    
    // 💡 수정 2: handleOpenModal은 이제 실제 인덱스를 받습니다.
    const handleOpenModal = (actualIndex: number) => {
        setEditingIndex(actualIndex);
        setModalOpen(true);
    };    

    // const handleSave = (time: string, brightness: number) => {
    //     if (editingIndex === null) return;
    //     setMonthData((prev) => {
    //     const newData = [...prev[nowMonth]];
    //     newData[editingIndex] = { time, brightness };
    //     return { ...prev, [nowMonth]: newData };
    //     });
    //     setModalOpen(false);
    // };

    // const handleAddLine = () => {
    //     setMonthData((prev) => {
    //     const current = prev[nowMonth];
    //     if (current.length >= 10) return prev;
    //     return { ...prev, [nowMonth]: [...current, { time: "00:00", brightness: 0 }] };
    //     });
    // };

    // const handleDeleteLine = (index: number) => {
    //     setMonthData((prev) => {
    //     const current = prev[nowMonth];
    //     if (current.length <= 1) return prev;
    //     const newList = current.filter((_, i) => i !== index);
    //     return { ...prev, [nowMonth]: newList };
    //     });
    // };


    // 시간(m) 값을 HH:MM 형식의 문자열로 변환하는 헬퍼 함수
    // const minutesToHHMM = (minutes: number) => {
    //     if (minutes === 0) return '';
    //     const hours = Math.floor(minutes / 60);
    //     const mins = minutes % 60;
    //     return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
    // };


    // HH:MM 형식의 문자열을 시간(분) 값으로 변환하는 헬퍼 함수
    // const HHMMToMinutes = (timeString: string): number => {
    //     if (!timeString) return 0;
    //     const [hours, minutes] = timeString.split(':').map(Number);
    //     if (isNaN(hours) || isNaN(minutes)) return 0;
    //     return hours * 60 + minutes;
    // };

    /**
     * @description "hh:mm am/pm" 형식의 시간 문자열을 자정으로부터의 총 분(minutes)으로 변환
     * @param timeString "09:30 AM" 또는 "03:45 PM"과 같은 문자열
     * @returns 자정으로부터의 총 분 (0~1439)
     */
    // const HHMMToMinutes = (timeString: string): number => {
    //     const parts = timeString.trim().split(' ');
    //     if (parts.length !== 2) {
    //         console.error("Invalid time format (expected 'hh:mm am/pm'):", timeString);
    //         return 0; // 변환 실패 시 0분(자정)으로 처리
    //     }

    //     const [time, period] = parts;
    //     const [hourStr, minuteStr] = time.split(':');

    //     let hour = parseInt(hourStr, 10);
    //     const minute = parseInt(minuteStr, 10);

    //     // 24시간 형식으로 변환 (0~23)
    //     if (period.toLowerCase() === 'pm' && hour !== 12) {
    //         hour += 12;
    //     } else if (period.toLowerCase() === 'am' && hour === 12) {
    //         // Midnight (12:xx am) is 00:xx
    //         hour = 0;
    //     }




    /**
     * 월별 시간 밝기 값 전송할 때 아래 조건 필터
     * -월별 순서 정렬
     * -is_active 필드 제외
     */
    const orderedKeys = Array.from({ length: 12 }, (_, i) => `${i + 1}M`); // ["1M","2M",...,"12M"]
    const filteredMValues = Object.fromEntries(
        orderedKeys.map((key) => [
            key,
            //(mValues[key] || []).map(({ is_active, ...rest }) => rest), // is_active 제외
            (mValues[key] || []).map(({ time, bright }) => [HHMMToMinutes(String(time)), bright]), // ⬅️ 배열 [time, bright] 형태
        ])
    );

    // here
    // 현재 월의 활성화된 슬롯 목록 (UI 렌더링에 사용)
    // const currentActiveSlots = useMemo(() => {
    //     // mValues[currentMonthKey]가 없으면 빈 배열 사용
    //     return (mValues[currentMonthKey] || []).filter(slot => slot.is_active);
    // }, [mValues, currentMonthKey]);

    // 💡 수정 1: useMemo를 수정하여 실제 인덱스(actualIndex)를 슬롯 객체에 포함
    const currentActiveSlots = useMemo(() => {
        return (mValues[currentMonthKey] || []).map((slot, actualIndex) => ({
            ...slot,
            actualIndex, // handleOpenModal 실제 배열 인덱스
        })).filter(slot => slot.is_active);
    }, [mValues, currentMonthKey]);

    /**
     * @description 활성화된 슬롯 목록(currentActiveSlots)에서의 인덱스를
     * 전체 10개 슬롯 배열(mValues[currentMonthKey])의 실제 인덱스로 변환
     * @param activeIndex currentActiveSlots에서의 순서 (0, 1, 2, ...)
     * @returns mValues에서의 실제 인덱스 (0~9)
     */
    const getActualIndex = (activeIndex: number): number | undefined => {
        const slots = mValues[currentMonthKey] || [];
        let activeCounter = -1;
        for (let i = 0; i < slots.length; i++) {
            if (slots[i].is_active) {
                activeCounter++;
                if (activeCounter === activeIndex) {
                    return i;
                }
            }
        }
        return undefined;
    };

    // here
    // 💡 수정: MQTT 프로토콜 포맷에 맞게 TimeN과 월별 데이터를 함께 생성
    // const generateMqttPayloadForMonth = () => {
    //     const TimeN: number[] = [];
    //     const monthDataPayload: Record<string, [number, number][]> = {};

    //     orderedKeys.forEach((key) => {
    //         const slots = mValues[key] || [];
            
    //         // 1. TimeN: 활성화된 슬롯의 개수만 카운트 (최대 10개)
    //         // 슬롯 개수는 is_active와 관계없이 배열에 있는 수만큼으로 하는 게 일반적일 수 있으나,
    //         // '월별 설정 개수'라는 정의에 따라 '데이터가 있는' 슬롯의 개수로 가정합니다.
    //         // 여기서는 슬롯 배열의 전체 길이 (10)를 사용하겠습니다. (혹은 .filter(s => s.time > 0 || s.bright > 0).length 로 변경 가능)
    //         // TimeN은 "월별 설정 개수"로 정의하셨으므로, 일단 *전체 슬롯 개수(10개)*로 처리합니다.
    //         // **[재해석]:** TimeN의 12개 값은 1월부터 12월까지의 '활성화된 설정 슬롯 개수(최대 10)'를 의미하는 것으로 재해석하고 코드를 수정합니다.
    //         const activeSlots = slots.filter(slot => slot.is_active); 
    //         TimeN.push(activeSlots.length); 

    //         // 2. 월별 데이터: [시간(분), 밝기] 쌍으로 변환 (is_active가 true인 항목만 포함)
    //         monthDataPayload[key] = activeSlots.map(({ time, bright }) => 
    //             [HHMMToMinutes(String(time)), bright]
    //         ); 
    //     });

    //     return {
    //         TimeN: TimeN,
    //         ...monthDataPayload,
    //     };
    // };
    const generateMqttPayloadForMonthX = () => {
        const TimeN: number[] = [];
        const monthDataPayload: Record<string, [number, number][]> = {};
        const orderedKeys = Array.from({ length: 12 }, (_, i) => `${i + 1}M`); // ["1M","2M",...,"12M"]

        orderedKeys.forEach((key) => {
            const slots = mValues[key] || [];
            
            // 1. is_active가 true인 슬롯만 필터링
            const activeSlots = slots.filter(slot => slot.is_active); 

            // 2. TimeN: 활성화된 슬롯의 개수
            TimeN.push(activeSlots.length); 

            // 3. 월별 데이터: [시간(분), 밝기 값] 쌍으로 변환
            // HHMMToMinutes 함수는 "HH:MM" 문자열을 분(number)으로 변환한다고 가정합니다.
            monthDataPayload[key] = activeSlots.map(({ time, bright }) => {
                let timeValue = String(time);

                // 💡 수정: time 값이 "0" 또는 0인 경우, 기본 문자열 시간으로 정규화
                if (timeValue === "0" || timeValue === "00:00") {
                    timeValue = "12:00 AM"; // 자정을 나타내는 문자열로 대체
                }
                
                // 정규화된 timeValue를 사용하여 분으로 변환
                return [HHMMToMinutes(timeValue), bright]; 
            }); 
        });

        return {
            TimeN: TimeN,
            ...monthDataPayload,
        };
    };


    // DB에서 월별 데이터 가져오기
    const fetchMonthData = async (month: number) => {
        if (!selectedSiteId || !selectedGroupId) return;
        try {
            const res = await axios.get(`${SOCKET_URL}/api/config/${selectedSiteId}/${selectedGroupId}/${month}`);
            const data: MSlot[] = res.data.map((d: any) => ({
                time: d.time ?? 0,
                bright: d.value ?? 0,
                is_active: d.is_active ?? false,
            }));

            // 슬롯 10개로 맞추기
            const padded = Array.from({ length: 10 }, (_, i) =>
                data[i] || { time: 0, bright: 0, is_active: false }
            );
            setMValues(prev => ({ ...prev, [`${month}M`]: padded }));
        } catch (err) {
            console.error("월별 데이터 불러오기 실패:", err);
        }
    };

    // DB 저장
    const saveMonthDataX = async (month: number) => {
        if (!selectedSiteId || !selectedGroupId) return;
        const slots = mValues[`${month}M`] || [];
        try {
            await axios.put(`${SOCKET_URL}/api/config/${selectedSiteId}/${selectedGroupId}/${month}`, {
                slots: slots.map((slot, index) => ({
                slot_no: index + 1,
                time: slot.time,
                value: slot.bright,
                is_active: slot.is_active,
                })),
            });

            alert("저장 완료");
        } catch (err) {
            console.error("저장 실패:", err);
        }
    };

    // 슬롯 값 변경
    const handleSlotChange = (
        monthKey: string,
        index: number,
        field: "time" | "bright" | "is_active",
        value: any
    ) => {
        setMValues(prev => {
            const slots = prev[monthKey] || Array.from({ length: 10 }, () => ({
                time: 0,
                bright: 0,
                is_active: false,
            }));
            const newSlots = [...slots];
            if (!newSlots[index]) newSlots[index] = { time: 0, bright: 0, is_active: false };

            //if (field === "time") newSlots[index].time = HHMMToMinutes(value);
            if (field === "time") newSlots[index].time = value;
            else if (field === "bright") newSlots[index].bright = value === "" ? 0 : parseInt(value, 10);
            else if (field === "is_active") newSlots[index].is_active = value;

            return { ...prev, [monthKey]: newSlots };
        });
    };       

    // ***************************************************************************
    //  월별 시간 리뉴얼 테스트
    // ***************************************************************************
    
    const [modalOpen, setModalOpen] = useState(false);
    const [editingIndex, setEditingIndex] = useState<number | null>(null); // 수정할 행 index
    const [defaultTime, setDefaultTime] = useState("00:00");
    const [defaultBrightness, setDefaultBrightness] = useState(0);    

    const [monthData, setMonthData] = useState<(TimeValue[] | null)[]>(
        // Array(MONTHS).fill(null)
        Array.from({ length: 12 }, () => [])  // 12개월 각각 빈 배열로 초기화
    );


    /**
     * minutes (0~1439) → "HH:MM AM/PM"
     */
    function minutesToHHMM(minutes: number) {
        const h24 = Math.floor(minutes / 60);
        const m = minutes % 60;

        const period = h24 >= 12 ? "PM" : "AM";
        let h12 = h24 % 12;
        if (h12 === 0) h12 = 12;

        return `${String(h12).padStart(2, "0")}:${String(m).padStart(2, "0")} ${period}`;
    }        

    //     // 총 분 계산
    //     return hour * 60 + minute;
    // };
    const HHMMToMinutes = (timeString: string): number => {
        const trimmedString = timeString.trim();
        
        // 💡 추가: "0" 또는 빈 문자열이 들어오면 0분으로 처리하고 로그를 찍지 않음 (Silent Fail)
        if (trimmedString === "0" || trimmedString === "") {
            return 0;
        }        
        const parts = trimmedString.split(' ');

        if (parts.length === 2) {
            // CASE 1: "hh:mm am/pm" 형식 처리 (기존 로직)
            const [time, period] = parts;
            const [hourStr, minuteStr] = time.split(':');

            if (!hourStr || !minuteStr) return 0;

            let hour = parseInt(hourStr, 10);
            const minute = parseInt(minuteStr, 10);

            if (period.toLowerCase() === 'pm' && hour !== 12) {
                hour += 12;
            } else if (period.toLowerCase() === 'am' && hour === 12) {
                hour = 0;
            }
            return hour * 60 + minute;
        } else if (trimmedString.includes(':')) {
            // CASE 2: "HH:MM:SS" 또는 "HH:MM" 형식 처리 (00:00:00 대응)
            const timeParts = trimmedString.split(':');
            
            const hour = parseInt(timeParts[0], 10);
            const minute = parseInt(timeParts[1], 10);
            
            if (isNaN(hour) || isNaN(minute)) {
                console.error("Invalid time format (contains ':' but failed to parse HH:MM):", trimmedString);
                return 0;
            }
            // 24시간 기준으로 분 계산
            return hour * 60 + minute;
        }

        // 기타 예상치 못한 형식
        console.error("Invalid time format (expected 'hh:mm am/pm' or 'HH:MM:SS'):", trimmedString);
        return 0;
    };

    // DB minutes 배열 → UI용 객체 배열
    function convertDBMonthDataToUI(dbData: any) {
        const uiMonthData: {time: string; value: number}[][] = [];

        for (let i = 1; i <= 12; i++) {
            const monthKey = `${i}M`;
            const raw = dbData[monthKey];

            if (!raw || !Array.isArray(raw)) {
            uiMonthData.push([]); // 데이터 없으면 빈 배열
            continue;
            }

            const formatted = raw.map(([minutes, bright]: [number, number]) => ({
            time: minutesToHHMM(minutes), // 여기서 AM/PM 포함 변환
            value: bright,
            }));

            uiMonthData.push(formatted);
        }

        return uiMonthData;
    }

    const getMonthData = async () => {
        if (!selectedSiteId || !selectedGroupId) return;

        try {
                const res = await axios.get(`${SOCKET_URL}/api/month/get`, {
                params: { site_id: selectedSiteId, group_id: selectedGroupId },
            });

            // if (res.data) {
            //     setMonthData(res.data); // { TimeN, "1M", "2M", ... } 구조 그대로 들어옴
            // }
            if (res.data) {
                const uiData = convertDBMonthDataToUI(res.data);
                //console.log("월별 설정 조회:", uiData);
                setMonthData(uiData); // 이제 monthData[0], monthData[1] ... 형태로 UI 렌더링 가능
            }

        } catch (err) {
            console.error("월별 설정 조회 오류:", err);
        }
    };

    const saveMonthData = async (monthPayload: any) => {
    if (!selectedSiteId || !selectedGroupId) return;

    try {
        await axios.post(`${SOCKET_URL}/api/month/save`, {
            site_id: selectedSiteId,
            group_id: selectedGroupId,
            monthPayload,   // 기존에 사용 중인 월별 설정 데이터
        });

        await getMonthData();
        // alert("월별 설정이 저장되었습니다 ✅");
    } catch (err) {
        console.error("월별 설정 저장 오류:", err);
    }
    };

    // 초기 데이터 로드
    useEffect(() => {

        getMonthData();
    }, [selectedSiteId, selectedGroupId]);


    // 입력 행 추가
    function addRow(monthIndex: number) {
        setMonthData((prev) => {
        const copy = [...prev];
        const arr = copy[monthIndex] ? [...copy[monthIndex]!] : [];
        if (arr.length >= MAX_ROWS) return copy;
        arr.push({ time: "12:00 AM", value: 0 });
        copy[monthIndex] = arr;
        return copy;
        });
    }

    // 입력 행 삭제
    function removeRow(monthIndex: number, rowIndex: number) {
        setMonthData((prev) => {
        const copy = [...prev];
        const arr = copy[monthIndex] ? [...copy[monthIndex]!] : [];
        arr.splice(rowIndex, 1);
        copy[monthIndex] = arr.length ? arr : null;
        return copy;
        });
    }

    // 행 값 수정
    const updateRow = (
        monthIndex: number,
        rowIndex: number,
        time: string,
        brightness: number
    ) => {
        setMonthData((prev) => {
        const copy = [...prev];
        const arr = copy[monthIndex] ? [...copy[monthIndex]!] : [];
        arr[rowIndex] = { time, value: brightness };
        copy[monthIndex] = arr;
        return copy;
        });
    };

    const openModalForEdit = (
        rowIndex: number,
        currentTime: string,
        currentBrightness: number
    ) => {
        setEditingIndex(rowIndex);
        setDefaultTime(currentTime);
        setDefaultBrightness(currentBrightness);
        setModalOpen(true);
    };

    const handleModalSave = (time: string, brightness: number) => {
        if (editingIndex !== null) {
        updateRow(nowMonth - 1, editingIndex, time, brightness);
        }
        setModalOpen(false);
    };

    // MQTT 전송용 Payload 생성 함수
    const generateMqttPayloadForMonth = (data: (any[] | null)[]) => {
        const TimeN: number[] = [];
        const monthDataPayload: Record<string, [number, number][] | null> = {};
        const orderedKeys = Array.from({ length: 12 }, (_, i) => `${i + 1}M`); // "1M" ~ "12M"

        orderedKeys.forEach((key, index) => {
            const monthSlots = data[index];

            // 월 데이터가 없으면 null 처리
            if (!monthSlots || monthSlots.length === 0) {
            TimeN.push(0);
            monthDataPayload[key] = null;
            return;
            }

            // TimeN: 각 월별 데이터 개수
            TimeN.push(monthSlots.length);

            // 월별 데이터: [시간(분), 밝기값] 쌍 배열
            monthDataPayload[key] = monthSlots.map(({ time, value }) => {
            let timeValue = time || "00:00";
            if (timeValue === "0" || timeValue === "00:00") timeValue = "12:00";
            return [HHMMToMinutes(timeValue), value];
            });
        });

        return {
            TimeN,
            ...monthDataPayload,
        };
    };


    // ***************************************************************************
    // ***************************************************************************
    // ***************************************************************************    

    // ***************************************************************************
    // 모드 별 시간 설정 관련
    // ***************************************************************************

    // 상태 관리: 모달 열림 여부와 선택된 시간
    const [isModeOnTimeModalOpen, setModeOnTimeIsModalOpen] = useState(false);
    const [selectedModeOnTime, setSelectedModeOnTime] = useState("12:00 AM");
    const [isModeOffTimeModalOpen, setModeOffTimeIsModalOpen] = useState(false);
    const [selectedModeOffTime, setSelectedModeOffTime] = useState("12:00 AM");

    // OnTime 모달 열기 함수
    const handleOpenModeOnTimeModal = () => {
        setModeOnTimeIsModalOpen(true);
    };
    // OnTime 모달 닫기 함수
    const handleCloseModeOnTimeModal = () => {
        setModeOnTimeIsModalOpen(false);
    };
    // OffTime 모달 열기 함수
    const handleOpenModeOffTimeModal = () => {
        setModeOffTimeIsModalOpen(true);
    };
    // OnTime 모달 닫기 함수
    const handleCloseModeOffTimeModal = () => {
        setModeOffTimeIsModalOpen(false);
    };

    // onTime 시간 저장 함수
    const handleSaveModeOnTime = (onTime: string) => {
        setSelectedModeOnTime(onTime);
        setModeOnTimeIsModalOpen(false); // 저장 후 모달 닫기
    };
    // offTime 시간 저장 함수
    const handleSaveModeOffTime = (offTime: string) => {
        setSelectedModeOffTime(offTime);
        setModeOffTimeIsModalOpen(false); // 저장 후 모달 닫기
    };

    // ***************************************************************************
    //  mqtt 전송 관련
    // ***************************************************************************       

    const formatpaddedId = (num: number, targetLength: number): string => {
        // 1. 숫자를 문자열로 변환합니다.
        const str = String(num);
        // 2. padStart() 메서드를 사용하여 문자열의 시작 부분을 '0'으로 채웁니다.
        return str.padStart(targetLength, '0');
    }

    

    // 그룹 제어 설정 값
    const handleApply_GroupSets = (tabNumber: number) => {
        closeConfirmModal()
        if (!socket || !selectedSiteId || !selectedGroupId) return;

        const sid: string = formatpaddedId(selectedSiteId,4);
        const gid: string = formatpaddedId(selectedGroupId,3);

        let payload: any = { socketId:socket.id , siteId: sid, groupId: gid };
        // let payload: any = { siteId: selectedSiteId, groupId: selectedGroupId };

        switch (groupSettingTab) {
            case 1:
            let LEDSts = brightness;
            let LEDTst = brightnessMode;
            payload = {
                ...payload,
                tabNumber,
                LEDSts,
                LEDTst, // 라디오 선택지 값 포함
            };
            break;
            case 2:
                payload = {
                    ...payload,
                    tabNumber,
                };
            break;
            case 3:
                let LDistS = currentDistanceLeft; //distanceLeft;
                let RDistS = currentDistanceRight; //distanceRight;
                let DDistS = currentDistanceBottom; //distanceBottom;
                payload = {
                    ...payload,
                    tabNumber,
                    LDistS,
                    RDistS,
                    DDistS,
                };
                // DB 저장 함수
                saveDistancehData(LDistS,RDistS,DDistS);
                fetchDeviceSetInfo();
            break;

            case 4:
                let mode = currentLedmode; //led_mode;
                let maxLED = currentMaxBright; //maxBright;
                let minLED = currentMinBright; //minBright;
                let LEDOnT = currentKeepOnTime; //keepOnTime;
                let sLEDN = currentSideOnLed; //sideOnLed;
                let OnT = 0;
                let OffT = 0;
                if (mode === 1) {
                    OnT = 0;
                    OffT = 0;
                } else {
                    OnT = HHMMToMinutes(selectedModeOnTime);
                    OffT = HHMMToMinutes(selectedModeOffTime);
                }

                payload = {
                    ...payload,
                    tabNumber,
                    mode,
                    maxLED,
                    minLED,
                    LEDOnT,
                    sLEDN,
                    OnT,
                    OffT,
                };
                // DB 저장 함수
                saveLedModehData(mode,minLED,maxLED,LEDOnT,sLEDN,OnT,OffT);
                fetchDeviceSetInfo();
            break;

            case 5:
                // let timeN = 10;
                // here
                // 💡 수정: generateMqttPayloadForMonth 함수를 사용하여 TimeN과 월별 데이터를 모두 포함
                const monthPayload = generateMqttPayloadForMonth(monthData);

                payload = {
                    ...payload,
                    tabNumber,
                    // timeN,
                    // ...filteredMValues,
                    ...monthPayload,
                };
                saveMonthData(monthPayload);
            break;

        }
        socket.emit('group_publish', payload);
        //alert(`전송 데이터: ${JSON.stringify(payload, null, 2)}`);
    };    

    // ***************************************************************************
    // ***************************************************************************
    // ***************************************************************************   
  
    return (
        <>
        <MediaQuery maxWidth={767}>        

            {/* ✅ 5개의 탭 버튼 */}
            <Style.MenuArea>
                {/* 계정 등급이 user일때는 1번 탭만 노출 */}
                {currentUser?.role === 'user' ? (
                    <>
                    {[1].map((num) => (
                    <Style.MenuFrame
                        key={num}
                        onClick={() => setGroupSettingTab(num)}
                    >

                        <Style.MenuIcon>
                                <img src={MenuLedSelectIcon} alt="" style={{ width: '24px', height: '24px' }} />
                        </Style.MenuIcon>

                            <Style.MenuText isSelected={true}>
                                {menuTexts[num].split(' | ').map((line, index) => (
                                    <React.Fragment key={index}>
                                        {line}
                                        {index < menuTexts[num].split(' | ').length - 1 && <br />}
                                    </React.Fragment>
                                ))}
                            </Style.MenuText>                  

                    </Style.MenuFrame>
                    ))}
                    </>
                ) : (
                    <>
                    {menuIds.map((num) => {
                        const isSelected = num === groupSettingTab;
                        // 선택 여부에 따라 사용할 아이콘 경로 결정
                        const iconSrc = isSelected 
                            ? iconComponents[num].selected  // 선택된 경우: 색상 아이콘
                            : iconComponents[num].default;  // 선택되지 않은 경우: 기본 아이콘                        
                        return (
                        
                        <Style.MenuFrame
                            key={num}
                            onClick={() => setGroupSettingTab(num)}
                        >

                            <Style.MenuIcon
                                style={{ 
                                    backgroundImage: `url(${iconSrc})` 
                                }}
                            >
                            </Style.MenuIcon>
                            
                            <Style.MenuText isSelected={isSelected}>
                                {menuTexts[num].split(' | ').map((line, index) => (
                                    <React.Fragment key={index}>
                                        {line}
                                        {index < menuTexts[num].split(' | ').length - 1 && <br />}
                                    </React.Fragment>
                                ))}
                            </Style.MenuText>

                        </Style.MenuFrame>
                        )
                        })}
                    </>
                )}
            </Style.MenuArea>
            {/* ✅ 5개의 탭 버튼 끝 */}


            {/* ✅ 탭별 내용 */}
            {/* Tab 1 */}
            {groupSettingTab === 1 && (
                <Style.CommonMenuArea>

                    <Style.CommonMenuTitleText
                        isMenuSelected={true} // 현재 탭이 1번인지 확인
                    >
                        LED 제어 테스트
                    </Style.CommonMenuTitleText>

                    <Style.LedControlSelectFrame>

                        {ledButtons.map((button) => {
                            // 🔑 현재 버튼의 value가 상태와 일치하는지 확인
                            const isSelected = button.value === brightnessMode;
                            
                            return (
                                <Style.LedControlSelectFocus isSelected={isSelected}
                                    key={button.value}
                                    onClick={() => setBrightnessMode(button.value)}
                                >
                                    <Style.LedControlSelectFocusText 
                                        isSelected={isSelected}
                                        isMenuSelected={true}
                                    >
                                        {button.label}
                                    </Style.LedControlSelectFocusText>
                                </Style.LedControlSelectFocus>
                            );
                        })}

                    </Style.LedControlSelectFrame>

                    <Style.LedBrightFrame>

                        <Style.LedBrightTextFrame>
                            <Style.LedBrightText1 isMenuSelected={true}>
                                밝기
                            </Style.LedBrightText1>
                            <Style.LedBrightText2 isMenuSelected={true}>
                                {brightness}
                            </Style.LedBrightText2>                            
                        </Style.LedBrightTextFrame>

                        <Style.LedBrightProgressFrame>
                            <Style.LedBrightProgressText
                                isMenuSelected={true}
                            >
                                0
                            </Style.LedBrightProgressText>
                                <Style.CommonProgressBarFrame>
                                    <Style.CommonProgressBar>
                                        <Style.CommonProgressBarCursor
                                            min="0"
                                            max="100"
                                            value={brightness}
                                            onChange={(e) => setBrightness(Number(e.target.value))}
                                            level={brightness} 
                                            $cursorUrl={CursorSVG}
                                        >
                                            
                                        </Style.CommonProgressBarCursor>
                                    </Style.CommonProgressBar>
                                </Style.CommonProgressBarFrame>
                            <Style.LedBrightProgressText
                                isMenuSelected={true}
                            >
                                100
                            </Style.LedBrightProgressText>
                        </Style.LedBrightProgressFrame>

                    </Style.LedBrightFrame>

                    <Style.CommonMenuConfirm
                        isMenuSelected={groupSettingTab === 1}
                        disabled={groupSettingTab !== 1}
                        onClick={()=> 
                            {
                                setGroupSettingTab(1)
                                openConfirmModal()
                            }
                        }
                    >
                        적용
                    </Style.CommonMenuConfirm>


                </Style.CommonMenuArea>
            )}

            {/* Tab 2 */}
            {groupSettingTab === 2 && (
            <Style.CommonMenuArea>

                <Style.CommonMenuTitle>
                    <Style.CommonMenuTitleText
                    isMenuSelected={groupSettingTab === 2}>
                        디바이스 리셋
                    </Style.CommonMenuTitleText>
                </Style.CommonMenuTitle>

                <Style.LedBrightFrame>
                    <Style.LedBrightText1 isMenuSelected={groupSettingTab === 2}>
                        적용 버튼을 누르면 <br></br> 그룹 전체의 디바이스를 <br></br> 리셋 합니다.
                    </Style.LedBrightText1>
                </Style.LedBrightFrame>

                <Style.CommonMenuConfirm
                    isMenuSelected={groupSettingTab === 2}
                    disabled={groupSettingTab !== 2}                 
                    onClick={()=> 
                        {
                            setGroupSettingTab(groupSettingTab)
                            openConfirmModal()
                        }
                    }
                >
                    적용
                </Style.CommonMenuConfirm>

            </Style.CommonMenuArea>
            )}

            {/* Tab 3 */}
            {groupSettingTab === 3 && (
            <Style.CommonMenuArea>

                <Style.CommonMenuTitle>
                    <Style.CommonMenuTitleText
                    isMenuSelected={groupSettingTab === 3}>
                        감지 센서 설정
                    </Style.CommonMenuTitleText>
                </Style.CommonMenuTitle>

                <Style.SensorSetFrame>
                    <Style.SensorSetProgressFrame>
                        <Style.SensorSetProgressTextLeft
                            isMenuSelected={groupSettingTab === 3}
                        >
                            왼쪽
                        </Style.SensorSetProgressTextLeft>
                        <Style.CommonProgressBarFrame>
                            <Style.CommonProgressBar>
                                <Style.CommonProgressBarCursor
                                    min="1"
                                    max="100"
                                    value={currentDistanceLeft} 
                                    onChange={handleDistanceLeftChange} 
                                    level={currentDistanceLeft}  
                                    $cursorUrl={CursorSVG}
                                >
                                </Style.CommonProgressBarCursor>
                            </Style.CommonProgressBar>
                        </Style.CommonProgressBarFrame>
                        <Style.SensorSetProgressTextRight
                            isMenuSelected={groupSettingTab === 3}
                        >
                            {currentDistanceLeft} 
                        </Style.SensorSetProgressTextRight>
                    </Style.SensorSetProgressFrame>

                    <Style.SensorSetProgressFrame>
                        <Style.SensorSetProgressTextLeft
                            isMenuSelected={groupSettingTab === 3}
                        >
                            오른쪽
                        </Style.SensorSetProgressTextLeft>
                        <Style.CommonProgressBarFrame>
                            <Style.CommonProgressBar>
                                <Style.CommonProgressBarCursor
                                    min="1"
                                    max="100"
                                    value={currentDistanceRight}
                                    onChange={handleDistanceRightChange} 
                                    level={currentDistanceRight} 
                                    $cursorUrl={CursorSVG}
                                >
                                </Style.CommonProgressBarCursor>
                            </Style.CommonProgressBar>
                        </Style.CommonProgressBarFrame>
                        <Style.SensorSetProgressTextRight
                            isMenuSelected={groupSettingTab === 3}
                        >
                            {currentDistanceRight}
                        </Style.SensorSetProgressTextRight>
                    </Style.SensorSetProgressFrame>

                    <Style.SensorSetProgressFrame>
                        <Style.SensorSetProgressTextLeft
                            isMenuSelected={groupSettingTab === 3}
                        >
                            하단
                        </Style.SensorSetProgressTextLeft>
                        <Style.CommonProgressBarFrame>
                            <Style.CommonProgressBar>
                                <Style.CommonProgressBarCursor
                                    min="1"
                                    max="100"
                                    value={currentDistanceBottom}
                                    onChange={handleDistanceBottomChange} 
                                    level={currentDistanceBottom} 
                                    $cursorUrl={CursorSVG}
                                >
                                </Style.CommonProgressBarCursor>
                            </Style.CommonProgressBar>
                        </Style.CommonProgressBarFrame>
                        <Style.SensorSetProgressTextRight
                            isMenuSelected={groupSettingTab === 3}
                        >
                            {currentDistanceBottom}
                        </Style.SensorSetProgressTextRight>
                    </Style.SensorSetProgressFrame>

                </Style.SensorSetFrame>

                <Style.CommonMenuConfirm
                    isMenuSelected={groupSettingTab === 3}
                    disabled={groupSettingTab !== 3}
                    onClick={()=> 
                        {
                            setGroupSettingTab(3)
                            openConfirmModal()
                        }
                    }
                >
                    적용
                </Style.CommonMenuConfirm>

            </Style.CommonMenuArea>
            )}

            {/* Tab 4 */}
            {groupSettingTab === 4 && (
            <Style.CommonMenuArea>

                <Style.CommonMenuTitle>
                    <Style.CommonMenuTitleText
                        isMenuSelected={groupSettingTab === 4}
                    >
                        LED 동작 모드 설정
                    </Style.CommonMenuTitleText>
                </Style.CommonMenuTitle>                

                <Style.MotionSetFrame
                    onClick={openModeModal}
                >
                    <Style.MotionSetSelect
                        isMenuSelected={groupSettingTab === 4}
                    >
                        Mode {Number(currentLedmode)}
                    </Style.MotionSetSelect>
                    <Style.MotionSetSelectIcon
                        isMenuSelected={groupSettingTab === 4}
                        $imgUrl={MenuMotionArrowDownTabletIcon}
                        $selectedimgUrl={MenuMotionArrowDownFocusTabletIcon}
                    >
                    </Style.MotionSetSelectIcon>

                </Style.MotionSetFrame>

                <Style.MotionValueSetFrame>

                    <Style.MotionValueSetRow>

                        <Style.MotionValueSetCol>
                            <Style.MotionValueSetText
                                isMenuSelected={groupSettingTab === 4}
                            >
                                최소밝기
                            </Style.MotionValueSetText>
                            <Style.MotionValueSetDataFrame>
                                <Style.MotionValueSetValue
                                    isMenuSelected={groupSettingTab === 4}
                                    suppressContentEditableWarning={true} // 이 속성을 추가합니다.
                                    contentEditable="true"
                                    inputMode="numeric"
                                    // 🔑 onInput: 입력이 발생할 때마다 실행
                                    onInput={(e) => {
                                        // 1. 입력된 텍스트를 가져옵니다.
                                        let text = e.currentTarget.textContent || '';
                                        
                                        // 2. 텍스트에서 숫자('0'~'9')를 제외한 모든 문자를 제거합니다.
                                        let numericValue = text.replace(/[^0-9]/g, '');
                                        
                                        // 3. 만약 변경된 값이 있다면 DOM을 강제로 업데이트하여 숫자만 남깁니다.
                                        if (text !== numericValue) {
                                            e.currentTarget.textContent = numericValue;
                                        }

                                        // (선택) 상태를 실시간으로 업데이트하려면 여기서 setDisplayValue(numericValue)를 호출합니다.
                                    }}

                                    // onBlur: 포커스를 잃을 때 최종 값을 상태에 저장 (maxBright 업데이트)
                                    onBlur={(e) => {
                                        let finalValue = Number(e.currentTarget.textContent || 0);
                                        // 1. 값의 범위를 제한합니다.
                                        if (finalValue < 0) {
                                            finalValue = 0;
                                        } else if (finalValue > 100) {
                                            finalValue = 100;
                                        }
                                        // 2. 최종 값으로 상태를 업데이트합니다.
                                        if(1)
                                        setCurrentMinBright(finalValue);
                                        
                                        // 3. 화면에 보이는 값도 강제로 업데이트합니다. (필수)
                                        e.currentTarget.textContent = String(finalValue);
                                    }}
                                >
                                    {currentMinBright}
                                </Style.MotionValueSetValue>
                            </Style.MotionValueSetDataFrame>
                        </Style.MotionValueSetCol>

                        <Style.MotionValueSetCol>
                            <Style.MotionValueSetText
                                isMenuSelected={groupSettingTab === 4}
                            >
                                최대밝기
                            </Style.MotionValueSetText>
                            <Style.MotionValueSetDataFrame>
                                <Style.MotionValueSetValue
                                    isMenuSelected={groupSettingTab === 4}
                                    suppressContentEditableWarning={true} // 이 속성을 추가합니다.
                                    contentEditable="true"
                                    inputMode="numeric"
                                    // 🔑 onInput: 입력이 발생할 때마다 실행
                                    onInput={(e) => {
                                        // 1. 입력된 텍스트를 가져옵니다.
                                        let text = e.currentTarget.textContent || '';
                                        
                                        // 2. 텍스트에서 숫자('0'~'9')를 제외한 모든 문자를 제거합니다.
                                        let numericValue = text.replace(/[^0-9]/g, '');
                                        
                                        // 3. 만약 변경된 값이 있다면 DOM을 강제로 업데이트하여 숫자만 남깁니다.
                                        if (text !== numericValue) {
                                            e.currentTarget.textContent = numericValue;
                                        }

                                        // (선택) 상태를 실시간으로 업데이트하려면 여기서 setDisplayValue(numericValue)를 호출합니다.
                                    }}

                                    // onBlur: 포커스를 잃을 때 최종 값을 상태에 저장 (maxBright 업데이트)
                                    onBlur={(e) => {
                                        let finalValue = Number(e.currentTarget.textContent || 0);
                                        // 1. 값의 범위를 제한합니다.
                                        if (finalValue < 0) {
                                            finalValue = 0;
                                        } else if (finalValue > 100) {
                                            finalValue = 100;
                                        }
                                        // 2. 최종 값으로 상태를 업데이트합니다.
                                        setCurrentMaxBright(finalValue);
                                        
                                        // 3. 화면에 보이는 값도 강제로 업데이트합니다. (필수)
                                        e.currentTarget.textContent = String(finalValue);
                                    }}
                                >
                                    {currentMaxBright}
                                </Style.MotionValueSetValue>
                            </Style.MotionValueSetDataFrame>
                        </Style.MotionValueSetCol>

                    </Style.MotionValueSetRow>                      

                    <Style.MotionValueSetRow>

                        <Style.MotionValueSetCol>
                            <Style.MotionValueSetText
                                isMenuSelected={groupSettingTab === 4}
                            >
                                On<br></br>지속시간
                            </Style.MotionValueSetText>
                            <Style.MotionValueSetDataFrame>
                                <Style.MotionValueSetValue
                                    isMenuSelected={groupSettingTab === 4}
                                    suppressContentEditableWarning={true} // 이 속성을 추가합니다.
                                    contentEditable="true"
                                    inputMode="numeric"
                                    // 🔑 onInput: 입력이 발생할 때마다 실행
                                    onInput={(e) => {
                                        // 1. 입력된 텍스트를 가져옵니다.
                                        let text = e.currentTarget.textContent || '';
                                        
                                        // 2. 텍스트에서 숫자('0'~'9')를 제외한 모든 문자를 제거합니다.
                                        let numericValue = text.replace(/[^0-9]/g, '');
                                        
                                        // 3. 만약 변경된 값이 있다면 DOM을 강제로 업데이트하여 숫자만 남깁니다.
                                        if (text !== numericValue) {
                                            e.currentTarget.textContent = numericValue;
                                        }

                                        // (선택) 상태를 실시간으로 업데이트하려면 여기서 setDisplayValue(numericValue)를 호출합니다.
                                    }}

                                    // onBlur: 포커스를 잃을 때 최종 값을 상태에 저장 (maxBright 업데이트)
                                    onBlur={(e) => {
                                        let finalValue = Number(e.currentTarget.textContent || 0);
                                        // 1. 값의 범위를 제한합니다.
                                        if (finalValue < 1) {
                                            finalValue = 1;
                                        } else if (finalValue > 60) {
                                            finalValue = 60;
                                        }
                                        // 2. 최종 값으로 상태를 업데이트합니다.
                                        setCurrentKeepOnTime(finalValue);
                                        
                                        // 3. 화면에 보이는 값도 강제로 업데이트합니다. (필수)
                                        e.currentTarget.textContent = String(finalValue);
                                    }}
                                >
                                    {currentKeepOnTime}
                                </Style.MotionValueSetValue>
                            </Style.MotionValueSetDataFrame>
                        </Style.MotionValueSetCol>

                        <Style.MotionValueSetCol>
                            <Style.MotionValueSetText
                                isMenuSelected={groupSettingTab === 4}
                            >
                                좌우 On<br></br>LED 개수
                            </Style.MotionValueSetText>
                            <Style.MotionValueSetDataFrame>
                                <Style.MotionValueSetValue
                                    isMenuSelected={groupSettingTab === 4}
                                    suppressContentEditableWarning={true} // 이 속성을 추가합니다.
                                    contentEditable="true"
                                    inputMode="numeric"
                                    // 🔑 onInput: 입력이 발생할 때마다 실행
                                    onInput={(e) => {
                                        // 1. 입력된 텍스트를 가져옵니다.
                                        let text = e.currentTarget.textContent || '';
                                        
                                        // 2. 텍스트에서 숫자('0'~'9')를 제외한 모든 문자를 제거합니다.
                                        let numericValue = text.replace(/[^0-9]/g, '');
                                        
                                        // 3. 만약 변경된 값이 있다면 DOM을 강제로 업데이트하여 숫자만 남깁니다.
                                        if (text !== numericValue) {
                                            e.currentTarget.textContent = numericValue;
                                        }

                                        // (선택) 상태를 실시간으로 업데이트하려면 여기서 setDisplayValue(numericValue)를 호출합니다.
                                    }}

                                    // onBlur: 포커스를 잃을 때 최종 값을 상태에 저장 (maxBright 업데이트)
                                    onBlur={(e) => {
                                        let finalValue = Number(e.currentTarget.textContent || 0);
                                        // 1. 값의 범위를 제한합니다.
                                        if (finalValue < 0) {
                                            finalValue = 0;
                                        } else if (finalValue > 5) {
                                            finalValue = 5;
                                        }
                                        // 2. 최종 값으로 상태를 업데이트합니다.
                                        setCurrentSideOnLed(finalValue);
                                        
                                        // 3. 화면에 보이는 값도 강제로 업데이트합니다. (필수)
                                        e.currentTarget.textContent = String(finalValue);
                                    }}
                                >
                                    {currentSideOnLed}
                                </Style.MotionValueSetValue>
                            </Style.MotionValueSetDataFrame>
                        </Style.MotionValueSetCol>

                    </Style.MotionValueSetRow>

                    <Style.MotionValueSetRow>
                        {/* --- On Time 섹션 --- */}
                        <Style.MotionValueSetCol>
                            <Style.MotionValueSetText
                                isMenuSelected={groupSettingTab === 4}
                                // isDisabled={Number(currentLedmode) === 1} // (선택사항) 스타일에서 활용할 프롭
                            >
                                On Time
                            </Style.MotionValueSetText>
                            <Style.MotionInputDataValueTimeFrame
                                // 💡 수정: mode가 1이 아닐 때만 클릭 핸들러가 작동하도록 설정
                                onClick={() => Number(currentLedmode) !== 1 && handleOpenModeOnTimeModal()}
                                style={{ 
                                    opacity: Number(currentLedmode) === 1 ? 0.5 : 1, 
                                    cursor: Number(currentLedmode) === 1 ? "not-allowed" : "pointer" 
                                }}
                            >
                                <Style.MotionInputDataValueTimeText isMenuSelected={groupSettingTab === 4}>
                                    {selectedModeOnTime || "12:00 AM"}
                                </Style.MotionInputDataValueTimeText>
                            </Style.MotionInputDataValueTimeFrame>
                        </Style.MotionValueSetCol>

                        {/* --- Off Time 섹션 --- */}
                        <Style.MotionValueSetCol>
                            <Style.MotionValueSetText
                                isMenuSelected={groupSettingTab === 4}
                                // isDisabled={Number(currentLedmode) === 1}
                            >
                                Off Time
                            </Style.MotionValueSetText>
                            <Style.MotionInputDataValueTimeFrame
                                // 💡 수정: mode가 1이 아닐 때만 클릭 핸들러가 작동하도록 설정
                                onClick={() => Number(currentLedmode) !== 1 && handleOpenModeOffTimeModal()}
                                style={{ 
                                    opacity: Number(currentLedmode) === 1 ? 0.5 : 1, 
                                    cursor: Number(currentLedmode) === 1 ? "not-allowed" : "pointer" 
                                }}
                            >
                                <Style.MotionInputDataValueTimeText isMenuSelected={groupSettingTab === 4}>
                                    {selectedModeOffTime || "12:00 AM"}
                                </Style.MotionInputDataValueTimeText>
                            </Style.MotionInputDataValueTimeFrame>
                        </Style.MotionValueSetCol>
                    </Style.MotionValueSetRow>

                </Style.MotionValueSetFrame>                        

                {/* ✅ 모달 연결 */}
                <TimeModal
                    isOpen={isModeOnTimeModalOpen}
                    onClose={() => setModeOnTimeIsModalOpen(false)}
                    onSave={handleSaveModeOnTime}
                    defaultTime={selectedModeOnTime}
                />
                <TimeModal
                    isOpen={isModeOffTimeModalOpen}
                    onClose={() => setModeOffTimeIsModalOpen(false)}
                    onSave={handleSaveModeOffTime}
                    defaultTime={selectedModeOffTime}
                />

                <Style.CommonMenuConfirm
                    isMenuSelected={groupSettingTab === 4}
                    disabled={groupSettingTab !== 4}
                    onClick={()=> 
                        {
                            setGroupSettingTab(4)
                            openConfirmModal()
                        }
                    }
                >
                    적용
                </Style.CommonMenuConfirm>

            <>
            {/* 👇 LED 모드 선택 모달 컴포넌트 렌더링 */}
            {isModeModalOpen && (
                <ModeSelectionModal
                    open={isModeModalOpen}
                    currentMode={currentLedmode}
                    onSelect={handleModeSelect}
                    onClose={closeModeModal}
                />
            )}
            </>

            </Style.CommonMenuArea>
            )}

            <>
            {/* 👇 적용 버튼 모달 컴포넌트 렌더링 */}
            {isConfirmModalOpen && (
                <ConfirmButtonModal
                    isOpen={isConfirmModalOpen}
                    tabNum={groupSettingTab}
                    onAction={handleApply_GroupSets}
                    onClose={closeConfirmModal}
                />
            )}
            </>

            {/* Tab 5 */}
            {groupSettingTab === 5 && (

            <Style.MontlyMenuArea>

                <Style.CommonMenuTitle>
                    <Style.CommonMenuTitleText
                        isMenuSelected={groupSettingTab === 5} // 현재 탭이 1번인지 확인
                    >
                         월별 시간별 밝기 설정
                    </Style.CommonMenuTitleText>
                </Style.CommonMenuTitle>
                
                {/* 월별 탭 (1M ~ 12M) */}
                <Style.MontlyTabScrollFrame>

                    <Style.MontlyTabListFrame>
                        
                        {Array.from({ length: MONTHS }, (_, i) => i + 1).map((month) => { 
                            const isSelected = month === nowMonth; 
                            
                        return(
                            
                            // 🔑 3. isSelected에 따른 조건부 렌더링 적용
                            isSelected ? (
                                // 선택된 상태: Focus 스타일
                                <Style.MontlyTabFrame
                                    key={month}
                                    onClick={() => {
                                        setActiveMonthTab(month);
                                        setnowMonth(month);
                                    }}
                                >
                                    <Style.MontlyTabFocus>
                                    {/* {isSelected && <Style.MontlyTabFocusLine />} */}
                                        <Style.MontlyTabText
                                            isSelected={isSelected} 
                                            isMenuSelected={groupSettingTab === 5}
                                        >
                                            {month}월
                                        </Style.MontlyTabText>
                                    </Style.MontlyTabFocus>
                                    {/* <Style.MontlyTabFocusLine></Style.MontlyTabFocusLine> */}
                                </Style.MontlyTabFrame>    
                            ) : (
                                // 비선택 상태: 기본 스타일
                                <Style.MontlyTabFrame
                                    key={month}
                                    onClick={() => {
                                        setActiveMonthTab(month);
                                        setnowMonth(month);
                                    }}
                                >
                                    <Style.MontlyTabText
                                        isSelected={isSelected} 
                                        isMenuSelected={groupSettingTab === 5}
                                    >
                                        {month}월
                                    </Style.MontlyTabText>
                                </Style.MontlyTabFrame>
                            )
                        )})}
                        
                    </Style.MontlyTabListFrame>

                    <Style.MontlyInputFrame>

                        <Style.MontlyInputDataTitleFrame>
                            <Style.MontlyInputDataTitleLeft
                                isMenuSelected={groupSettingTab === 5}
                            >
                                시간
                            </Style.MontlyInputDataTitleLeft>
                            <Style.MontlyInputDataTitleRight
                                isMenuSelected={groupSettingTab === 5}
                            >
                                밝기
                            </Style.MontlyInputDataTitleRight>
                        </Style.MontlyInputDataTitleFrame>

                        {(monthData[nowMonth - 1] ?? []).map((row, idx) => (
                        <>
                            <Style.MontlyInputDataValueFrame key={idx}>
                                <Style.MontlyInputDataValueTimeFrame
                                    // 💡 수정: 모달에 넘길 기본값 변경
                                    onClick={() =>
                                        openModalForEdit(idx, row.time || "00:00", row.value || 0)
                                    }
                                >
                                    <Style.MontlyInputDataValueTimeText
                                        isMenuSelected={groupSettingTab === 5}
                                    >
                                        {/* 💡 수정: time 값이 0이면 빈 문자열 대신 '00:00' 표시 (시간 포맷 일관성) */}
                                        {row.time || "12:00 AM"}                                             
                                    </Style.MontlyInputDataValueTimeText>
                                </Style.MontlyInputDataValueTimeFrame>

                                <Style.MontlyInputDataValueBright
                                    onClick={() =>
                                        openModalForEdit(idx, row.time || "00:00", row.value || 0)
                                    }                                      
                                    isMenuSelected={groupSettingTab === 5}
                                >

                                    {row.value}
                                    
                                </Style.MontlyInputDataValueBright>


                                {/* 삭제 버튼: 활성화된 슬롯이 1개 초과일 때만 렌더링 (최소 1개 유지) */}
                                {(monthData[nowMonth - 1] ?? []).length > 1 && (
                                    <Style.MontlyInputDataValueDelete
                                        $imgUrl={MenuMonthlyMinusTabletIcon}
                                        onClick={() => removeRow(nowMonth - 1, idx)}
                                    />
                                )}                                    

                            </Style.MontlyInputDataValueFrame>

                            <Style.MontlyInputDataValueLineFrame>
                                <Style.MontlyInputDataValueLine />
                            </Style.MontlyInputDataValueLineFrame>
                        </>
                        ))}

                        <br></br>

                        {(!monthData[nowMonth - 1] || monthData[nowMonth - 1]!.length < MAX_ROWS) && (
                        <Style.MontlyInputDataValueAdd
                            onClick={() => addRow(nowMonth - 1)}
                            >
                            <Style.MontlyInputDataValueAddIcon
                                $imgUrl={MenuMonthlyPlusTabletIcon}
                            />
                            <Style.MontlyInputDataValueAddText>
                                추가
                            </Style.MontlyInputDataValueAddText>                                    
                        </Style.MontlyInputDataValueAdd>
                        )}

                    </Style.MontlyInputFrame>


                {/* ✅ 모달 연결 */}
                <TimeBrightModal
                    isOpen={modalOpen}
                    onClose={() => setModalOpen(false)}
                    onSave={handleModalSave}
                    defaultTime={defaultTime}
                    defaultBrightness={defaultBrightness}
                />

                </Style.MontlyTabScrollFrame>


                <Style.MonthlyConfirm
                    isMenuSelected={groupSettingTab === 5}
                    disabled={groupSettingTab !== 5}
                    onClick={()=> 
                        {
                            setGroupSettingTab(5)
                            openConfirmModal()
                        }
                    }
                >
                    적용
                </Style.MonthlyConfirm>

            </Style.MontlyMenuArea>
            )}

        </MediaQuery>

{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* **************************** 태블릿, 데스트톱 UI ****************************** */}

    <MediaQuery minWidth={768}>

        {currentUser?.role === 'user' ? (
        <>

        <Style.MainTabGridContainer>

        <Style.TabGridContainer>

            {/* ✅ 탭별 내용 */}
            {/* Tab 1 */}
            <Style.CommonMenuArea
                onClick={() => setGroupSettingTab(1)} // 클릭 시 1번 탭 활성화
                isMenuSelected={groupSettingTab === 1} // 현재 탭이 1번인지 확인
            >

                <Style.CommonMenuTitle>
                    <Style.CommonMenuTitleIcon
                        isMenuSelected={groupSettingTab === 1}
                        $menuUrl={MenuLedIcon}
                        $selectedMenuUrl={MenuLedSelectTabletIcon} // 👈 선택된 아이콘 URL 추가
                    >
                    </Style.CommonMenuTitleIcon>
                    <Style.CommonMenuTitleText
                        isMenuSelected={groupSettingTab === 1} // 현재 탭이 1번인지 확인
                    >
                        &nbsp;LED 제어 테스트
                    </Style.CommonMenuTitleText>
                </Style.CommonMenuTitle>

                {/* 숫자 입력 */}
                <Style.LedControlSelectFrame>

                    {ledButtons.map((button) => {
                        // 🔑 현재 버튼의 value가 상태와 일치하는지 확인
                        const isSelected = button.value === brightnessMode;
                        
                        return (
                            <Style.LedControlSelectFocus isSelected={isSelected}
                                key={button.value}
                                onClick={() => setBrightnessMode(button.value)}
                            >
                                <Style.LedControlSelectFocusText 
                                    isSelected={isSelected}
                                    isMenuSelected={groupSettingTab === 1}
                                >
                                    {button.label}
                                </Style.LedControlSelectFocusText>
                            </Style.LedControlSelectFocus>
                        );
                    })}

                </Style.LedControlSelectFrame>

                <Style.LedBrightFrame>

                    <Style.LedBrightTextFrame>
                        <Style.LedBrightText1 isMenuSelected={groupSettingTab === 1}>
                            밝기
                        </Style.LedBrightText1>
                        <Style.LedBrightText2 isMenuSelected={groupSettingTab === 1}>
                            {brightness}
                        </Style.LedBrightText2>                            
                    </Style.LedBrightTextFrame>

                    <Style.LedBrightProgressFrame>
                        <Style.LedBrightProgressText
                            isMenuSelected={groupSettingTab === 1}
                        >
                            0
                        </Style.LedBrightProgressText>
                        <Style.CommonProgressBarFrame>
                            <Style.CommonProgressBar>
                                <Style.CommonProgressBarCursor
                                    min="0"
                                    max="100"
                                    value={brightness}
                                    onChange={(e) => setBrightness(Number(e.target.value))}
                                    level={brightness} 
                                    $cursorUrl={CursorSVG}
                                >
                                </Style.CommonProgressBarCursor>
                            </Style.CommonProgressBar>
                        </Style.CommonProgressBarFrame>
                        <Style.LedBrightProgressText
                            isMenuSelected={groupSettingTab === 1}
                        >
                            100
                        </Style.LedBrightProgressText>
                    </Style.LedBrightProgressFrame>

                </Style.LedBrightFrame>
               
                <Style.CommonMenuConfirm
                    isMenuSelected={groupSettingTab === 1}
                    disabled={groupSettingTab !== 1} 
                    onClick={(e)=> 
                        {
                            // setGroupSettingTab(1)
                            e.stopPropagation(); // 영역 클릭 이벤트가 버튼 클릭에 중복되지 않도록 방지
                            openConfirmModal()
                            //handleApply_GroupSets(1)
                        }
                    }
                >
                    적용
                </Style.CommonMenuConfirm>

            </Style.CommonMenuArea>

            </Style.TabGridContainer>
        </Style.MainTabGridContainer>

        </>
        ) : (
        <>

        <Style.MainTabGridContainer>

        <Style.TabGridContainer>

            {/* ✅ 탭별 내용 */}
            {/* Tab 1 */}
            <Style.CommonMenuArea
                onClick={() => setGroupSettingTab(1)} // 클릭 시 1번 탭 활성화
                isMenuSelected={groupSettingTab === 1} // 현재 탭이 1번인지 확인
            >

                <Style.CommonMenuTitle>
                    <Style.CommonMenuTitleIcon
                        isMenuSelected={groupSettingTab === 1}
                        $menuUrl={MenuLedIcon}
                        $selectedMenuUrl={MenuLedSelectTabletIcon} // 👈 선택된 아이콘 URL 추가
                    >
                    </Style.CommonMenuTitleIcon>
                    <Style.CommonMenuTitleText
                        isMenuSelected={groupSettingTab === 1} // 현재 탭이 1번인지 확인
                    >
                        &nbsp;LED 제어 테스트
                    </Style.CommonMenuTitleText>
                </Style.CommonMenuTitle>

                {/* 숫자 입력 */}
                <Style.LedControlSelectFrame>

                    {ledButtons.map((button) => {
                        // 🔑 현재 버튼의 value가 상태와 일치하는지 확인
                        const isSelected = button.value === brightnessMode;
                        
                        return (
                            <Style.LedControlSelectFocus isSelected={isSelected}
                                key={button.value}
                                onClick={() => setBrightnessMode(button.value)}
                            >
                                <Style.LedControlSelectFocusText 
                                    isSelected={isSelected}
                                    isMenuSelected={groupSettingTab === 1}
                                >
                                    {button.label}
                                </Style.LedControlSelectFocusText>
                            </Style.LedControlSelectFocus>
                        );
                    })}

                </Style.LedControlSelectFrame>

                <Style.LedBrightFrame>

                    <Style.LedBrightTextFrame>
                        <Style.LedBrightText1 isMenuSelected={groupSettingTab === 1}>
                            밝기
                        </Style.LedBrightText1>
                        <Style.LedBrightText2 isMenuSelected={groupSettingTab === 1}>
                            {brightness}
                        </Style.LedBrightText2>                            
                    </Style.LedBrightTextFrame>

                    <Style.LedBrightProgressFrame>
                        <Style.LedBrightProgressText
                            isMenuSelected={groupSettingTab === 1}
                        >
                            0
                        </Style.LedBrightProgressText>
                        <Style.CommonProgressBarFrame>
                            <Style.CommonProgressBar>
                                <Style.CommonProgressBarCursor
                                    min="0"
                                    max="100"
                                    value={brightness}
                                    onChange={(e) => setBrightness(Number(e.target.value))}
                                    level={brightness} 
                                    $cursorUrl={CursorSVG}
                                >
                                </Style.CommonProgressBarCursor>
                            </Style.CommonProgressBar>
                        </Style.CommonProgressBarFrame>
                        <Style.LedBrightProgressText
                            isMenuSelected={groupSettingTab === 1}
                        >
                            100
                        </Style.LedBrightProgressText>
                    </Style.LedBrightProgressFrame>

                </Style.LedBrightFrame>
               
                <Style.CommonMenuConfirm
                    isMenuSelected={groupSettingTab === 1}
                    disabled={groupSettingTab !== 1} 
                    onClick={(e)=> 
                        {
                            // setGroupSettingTab(1)
                            e.stopPropagation(); // 영역 클릭 이벤트가 버튼 클릭에 중복되지 않도록 방지
                            openConfirmModal()
                            //handleApply_GroupSets(1)
                        }
                    }
                >
                    적용
                </Style.CommonMenuConfirm>

            </Style.CommonMenuArea>



            {/* Tab 2 */}
            <Style.CommonMenuArea
                isMenuSelected={groupSettingTab === 2} // 현재 탭이 1번인지 확인
                onClick={() => setGroupSettingTab(2)} // 클릭 시 1번 탭 활성화
            >

                <Style.CommonMenuTitle>
                    <Style.CommonMenuTitleIcon
                        isMenuSelected={groupSettingTab === 2}
                        $menuUrl={MenuResetIcon}
                        $selectedMenuUrl={MenuResetSelectTabletIcon} // 👈 선택된 아이콘 URL 추가
                    >
                    </Style.CommonMenuTitleIcon>
                    <Style.CommonMenuTitleText
                        isMenuSelected={groupSettingTab === 2} // 현재 탭이 1번인지 확인
                    >
                         &nbsp;&nbsp;&nbsp;디바이스 리셋
                    </Style.CommonMenuTitleText>
                </Style.CommonMenuTitle>
                
                <Style.LedBrightFrame>
                    <Style.LedBrightText1 isMenuSelected={groupSettingTab === 2}>
                        적용 버튼을 누르면 <br></br> 그룹 전체의 디바이스를 <br></br> 리셋 합니다.
                    </Style.LedBrightText1>
                </Style.LedBrightFrame>

                <Style.CommonMenuConfirm
                    isMenuSelected={groupSettingTab === 2}
                    disabled={groupSettingTab !== 2}                 
                    onClick={()=> 
                        {
                            setGroupSettingTab(2)
                            openConfirmModal()
                            //handleApply_GroupSets(2)
                        }
                    }
                >
                    적용
                </Style.CommonMenuConfirm>
            </Style.CommonMenuArea>



            {/* Tab 3 */}
            <Style.CommonMenuArea
                isMenuSelected={groupSettingTab === 3} // 현재 탭이 1번인지 확인
                onClick={() => setGroupSettingTab(3)} // 클릭 시 1번 탭 활성화
            >

                <Style.CommonMenuTitle>
                    <Style.CommonMenuTitleIcon
                        isMenuSelected={groupSettingTab === 3}
                        $menuUrl={MenuSensorIcon}
                        $selectedMenuUrl={MenuSensorSelectTabletIcon} // 👈 선택된 아이콘 URL 추가
                    >
                    </Style.CommonMenuTitleIcon>
                    <Style.CommonMenuTitleText
                        isMenuSelected={groupSettingTab === 3} // 현재 탭이 1번인지 확인
                    >
                         &nbsp;&nbsp;&nbsp;감지 센서 설정
                    </Style.CommonMenuTitleText>
                </Style.CommonMenuTitle>

                <Style.SensorSetFrame>
                    <Style.SensorSetProgressFrame>
                        <Style.SensorSetProgressTextLeft
                            isMenuSelected={groupSettingTab === 3}
                        >
                            왼쪽
                        </Style.SensorSetProgressTextLeft>
                        <Style.CommonProgressBarFrame>
                            <Style.CommonProgressBar>
                                <Style.CommonProgressBarCursor
                                    min="1"
                                    max="100"
                                    value={currentDistanceLeft} 
                                    // onChange={(e) => setDistanceLeft(Number(e.target.value))}
                                    onChange={handleDistanceLeftChange} 
                                    level={currentDistanceLeft}  
                                    $cursorUrl={CursorSVG}
                                >
                                </Style.CommonProgressBarCursor>
                            </Style.CommonProgressBar>
                        </Style.CommonProgressBarFrame>
                        <Style.SensorSetProgressTextRight
                            isMenuSelected={groupSettingTab === 3}
                        >
                            {/* {distanceLeft} */}
                            {currentDistanceLeft} 
                        </Style.SensorSetProgressTextRight>
                    </Style.SensorSetProgressFrame>

                    <Style.SensorSetProgressFrame>
                        <Style.SensorSetProgressTextLeft
                            isMenuSelected={groupSettingTab === 3}
                        >
                            오른쪽
                        </Style.SensorSetProgressTextLeft>
                        <Style.CommonProgressBarFrame>
                            <Style.CommonProgressBar>
                                <Style.CommonProgressBarCursor
                                    min="1"
                                    max="100"
                                    value={currentDistanceRight}
                                    // onChange={(e) => setDistanceRight(Number(e.target.value))}
                                    onChange={handleDistanceRightChange} 
                                    level={currentDistanceRight} 
                                    $cursorUrl={CursorSVG}
                                >
                                </Style.CommonProgressBarCursor>
                            </Style.CommonProgressBar>
                        </Style.CommonProgressBarFrame>
                        <Style.SensorSetProgressTextRight
                            isMenuSelected={groupSettingTab === 3}
                        >
                            {currentDistanceRight}
                        </Style.SensorSetProgressTextRight>
                    </Style.SensorSetProgressFrame>

                    <Style.SensorSetProgressFrame>
                        <Style.SensorSetProgressTextLeft
                            isMenuSelected={groupSettingTab === 3}
                        >
                            하단
                        </Style.SensorSetProgressTextLeft>
                        <Style.CommonProgressBarFrame>
                            <Style.CommonProgressBar>
                                <Style.CommonProgressBarCursor
                                    min="1"
                                    max="100"
                                    value={currentDistanceBottom}
                                    // onChange={(e) => setDistanceBottom(Number(e.target.value))}
                                    onChange={handleDistanceBottomChange} 
                                    level={currentDistanceBottom} 
                                    $cursorUrl={CursorSVG}
                                >
                                </Style.CommonProgressBarCursor>
                            </Style.CommonProgressBar>
                        </Style.CommonProgressBarFrame>
                        <Style.SensorSetProgressTextRight
                            isMenuSelected={groupSettingTab === 3}
                        >
                            {currentDistanceBottom}
                        </Style.SensorSetProgressTextRight>
                    </Style.SensorSetProgressFrame>

                </Style.SensorSetFrame>

                <Style.CommonMenuConfirm
                    isMenuSelected={groupSettingTab === 3}
                    disabled={groupSettingTab !== 3}
                    onClick={()=> 
                        {
                            setGroupSettingTab(3)
                            openConfirmModal()
                            //handleApply_GroupSets(3)
                        }
                    }
                >
                    적용
                </Style.CommonMenuConfirm>

            </Style.CommonMenuArea>



            {/* Tab 4 */}
            <Style.CommonMenuArea
                isMenuSelected={groupSettingTab === 4} // 현재 탭이 1번인지 확인
                onClick={() => {setGroupSettingTab(4)}} // 클릭 시 1번 탭 활성화
            >

                <Style.CommonMenuTitle>
                    <Style.CommonMenuTitleIcon
                        isMenuSelected={groupSettingTab === 4}
                        $menuUrl={MenuMotionIcon}
                        $selectedMenuUrl={MenuMotionSelectTabletIcon} // 👈 선택된 아이콘 URL 추가
                    >
                    </Style.CommonMenuTitleIcon>
                    <Style.CommonMenuTitleText
                        isMenuSelected={groupSettingTab === 4} // 현재 탭이 1번인지 확인
                    >
                         LED 동작 모드 설정
                    </Style.CommonMenuTitleText>
                </Style.CommonMenuTitle>

                <Style.MotionSetFrame
                    onClick={openModeModal}
                >
                    <Style.MotionSetSelect
                        isMenuSelected={groupSettingTab === 4}
                    >
                        Mode {Number(currentLedmode)}
                        {/* Mode {Number(currentLedmode)+1} */}
                    </Style.MotionSetSelect>
                    <Style.MotionSetSelectIcon
                        isMenuSelected={groupSettingTab === 4}
                        $imgUrl={MenuMotionArrowDownTabletIcon}
                        $selectedimgUrl={MenuMotionArrowDownFocusTabletIcon}
                    >
                    </Style.MotionSetSelectIcon>

                </Style.MotionSetFrame>

                <Style.MotionValueSetFrame>

                    <Style.MotionValueSetRow>

                        <Style.MotionValueSetCol>
                            <Style.MotionValueSetText
                                isMenuSelected={groupSettingTab === 4}
                            >
                                최소밝기
                            </Style.MotionValueSetText>
                            <Style.MotionValueSetDataFrame>
                                <Style.MotionValueSetValue
                                    isMenuSelected={groupSettingTab === 4}
                                    suppressContentEditableWarning={true} // 이 속성을 추가합니다.
                                    contentEditable="true"
                                    inputMode="numeric"
                                    // 🔑 onInput: 입력이 발생할 때마다 실행
                                    onInput={(e) => {
                                        // 1. 입력된 텍스트를 가져옵니다.
                                        let text = e.currentTarget.textContent || '';
                                        
                                        // 2. 텍스트에서 숫자('0'~'9')를 제외한 모든 문자를 제거합니다.
                                        let numericValue = text.replace(/[^0-9]/g, '');
                                        
                                        // 3. 만약 변경된 값이 있다면 DOM을 강제로 업데이트하여 숫자만 남깁니다.
                                        if (text !== numericValue) {
                                            e.currentTarget.textContent = numericValue;
                                        }

                                        // (선택) 상태를 실시간으로 업데이트하려면 여기서 setDisplayValue(numericValue)를 호출합니다.
                                    }}

                                    // onBlur: 포커스를 잃을 때 최종 값을 상태에 저장 (maxBright 업데이트)
                                    onBlur={(e) => {
                                        let finalValue = Number(e.currentTarget.textContent || 0);
                                        // 1. 값의 범위를 제한합니다.
                                        if (finalValue < 0) {
                                            finalValue = 0;
                                        } else if (finalValue > 100) {
                                            finalValue = 100;
                                        }
                                        // 2. 최종 값으로 상태를 업데이트합니다.
                                        if(1)
                                        setCurrentMinBright(finalValue);
                                        
                                        // 3. 화면에 보이는 값도 강제로 업데이트합니다. (필수)
                                        e.currentTarget.textContent = String(finalValue);
                                    }}
                                >
                                    {currentMinBright}
                                </Style.MotionValueSetValue>
                            </Style.MotionValueSetDataFrame>
                        </Style.MotionValueSetCol>

                        <Style.MotionValueSetCol>
                            <Style.MotionValueSetText
                                isMenuSelected={groupSettingTab === 4}
                            >
                                최대밝기
                            </Style.MotionValueSetText>
                            <Style.MotionValueSetDataFrame>
                                <Style.MotionValueSetValue
                                    isMenuSelected={groupSettingTab === 4}
                                    suppressContentEditableWarning={true} // 이 속성을 추가합니다.
                                    contentEditable="true"
                                    inputMode="numeric"
                                    // 🔑 onInput: 입력이 발생할 때마다 실행
                                    onInput={(e) => {
                                        // 1. 입력된 텍스트를 가져옵니다.
                                        let text = e.currentTarget.textContent || '';
                                        
                                        // 2. 텍스트에서 숫자('0'~'9')를 제외한 모든 문자를 제거합니다.
                                        let numericValue = text.replace(/[^0-9]/g, '');
                                        
                                        // 3. 만약 변경된 값이 있다면 DOM을 강제로 업데이트하여 숫자만 남깁니다.
                                        if (text !== numericValue) {
                                            e.currentTarget.textContent = numericValue;
                                        }

                                        // (선택) 상태를 실시간으로 업데이트하려면 여기서 setDisplayValue(numericValue)를 호출합니다.
                                    }}

                                    // onBlur: 포커스를 잃을 때 최종 값을 상태에 저장 (maxBright 업데이트)
                                    onBlur={(e) => {
                                        let finalValue = Number(e.currentTarget.textContent || 0);
                                        // 1. 값의 범위를 제한합니다.
                                        if (finalValue < 0) {
                                            finalValue = 0;
                                        } else if (finalValue > 100) {
                                            finalValue = 100;
                                        }
                                        // 2. 최종 값으로 상태를 업데이트합니다.
                                        setCurrentMaxBright(finalValue);
                                        
                                        // 3. 화면에 보이는 값도 강제로 업데이트합니다. (필수)
                                        e.currentTarget.textContent = String(finalValue);
                                    }}
                                >
                                    {currentMaxBright}
                                </Style.MotionValueSetValue>
                            </Style.MotionValueSetDataFrame>
                        </Style.MotionValueSetCol>

                    </Style.MotionValueSetRow>                      

                    <Style.MotionValueSetRow>

                        <Style.MotionValueSetCol>
                            <Style.MotionValueSetText
                                isMenuSelected={groupSettingTab === 4}
                            >
                                On<br></br>지속시간
                            </Style.MotionValueSetText>
                            <Style.MotionValueSetDataFrame>
                                <Style.MotionValueSetValue
                                    isMenuSelected={groupSettingTab === 4}
                                    suppressContentEditableWarning={true} // 이 속성을 추가합니다.
                                    contentEditable="true"
                                    inputMode="numeric"
                                    // 🔑 onInput: 입력이 발생할 때마다 실행
                                    onInput={(e) => {
                                        // 1. 입력된 텍스트를 가져옵니다.
                                        let text = e.currentTarget.textContent || '';
                                        
                                        // 2. 텍스트에서 숫자('0'~'9')를 제외한 모든 문자를 제거합니다.
                                        let numericValue = text.replace(/[^0-9]/g, '');
                                        
                                        // 3. 만약 변경된 값이 있다면 DOM을 강제로 업데이트하여 숫자만 남깁니다.
                                        if (text !== numericValue) {
                                            e.currentTarget.textContent = numericValue;
                                        }

                                        // (선택) 상태를 실시간으로 업데이트하려면 여기서 setDisplayValue(numericValue)를 호출합니다.
                                    }}

                                    // onBlur: 포커스를 잃을 때 최종 값을 상태에 저장 (maxBright 업데이트)
                                    onBlur={(e) => {
                                        let finalValue = Number(e.currentTarget.textContent || 0);
                                        // 1. 값의 범위를 제한합니다.
                                        if (finalValue < 1) {
                                            finalValue = 1;
                                        } else if (finalValue > 60) {
                                            finalValue = 60;
                                        }
                                        // 2. 최종 값으로 상태를 업데이트합니다.
                                        setCurrentKeepOnTime(finalValue);
                                        
                                        // 3. 화면에 보이는 값도 강제로 업데이트합니다. (필수)
                                        e.currentTarget.textContent = String(finalValue);
                                    }}
                                >
                                    {currentKeepOnTime}
                                </Style.MotionValueSetValue>
                            </Style.MotionValueSetDataFrame>
                        </Style.MotionValueSetCol>

                        <Style.MotionValueSetCol>
                            <Style.MotionValueSetText
                                isMenuSelected={groupSettingTab === 4}
                            >
                                좌우 On<br></br>LED 개수
                            </Style.MotionValueSetText>
                            <Style.MotionValueSetDataFrame>
                                <Style.MotionValueSetValue
                                    isMenuSelected={groupSettingTab === 4}
                                    suppressContentEditableWarning={true} // 이 속성을 추가합니다.
                                    contentEditable="true"
                                    inputMode="numeric"
                                    // 🔑 onInput: 입력이 발생할 때마다 실행
                                    onInput={(e) => {
                                        // 1. 입력된 텍스트를 가져옵니다.
                                        let text = e.currentTarget.textContent || '';
                                        
                                        // 2. 텍스트에서 숫자('0'~'9')를 제외한 모든 문자를 제거합니다.
                                        let numericValue = text.replace(/[^0-9]/g, '');
                                        
                                        // 3. 만약 변경된 값이 있다면 DOM을 강제로 업데이트하여 숫자만 남깁니다.
                                        if (text !== numericValue) {
                                            e.currentTarget.textContent = numericValue;
                                        }

                                        // (선택) 상태를 실시간으로 업데이트하려면 여기서 setDisplayValue(numericValue)를 호출합니다.
                                    }}

                                    // onBlur: 포커스를 잃을 때 최종 값을 상태에 저장 (maxBright 업데이트)
                                    onBlur={(e) => {
                                        let finalValue = Number(e.currentTarget.textContent || 0);
                                        // 1. 값의 범위를 제한합니다.
                                        if (finalValue < 0) {
                                            finalValue = 0;
                                        } else if (finalValue > 5) {
                                            finalValue = 5;
                                        }
                                        // 2. 최종 값으로 상태를 업데이트합니다.
                                        setCurrentSideOnLed(finalValue);
                                        
                                        // 3. 화면에 보이는 값도 강제로 업데이트합니다. (필수)
                                        e.currentTarget.textContent = String(finalValue);
                                    }}
                                >
                                    {currentSideOnLed}
                                </Style.MotionValueSetValue>
                            </Style.MotionValueSetDataFrame>
                        </Style.MotionValueSetCol>

                    </Style.MotionValueSetRow>

                    <Style.MotionValueSetRow>
                        {/* --- On Time 섹션 --- */}
                        <Style.MotionValueSetCol>
                            <Style.MotionValueSetText
                                isMenuSelected={groupSettingTab === 4}
                                // isDisabled={Number(currentLedmode) === 1} // (선택사항) 스타일에서 활용할 프롭
                            >
                                On Time
                            </Style.MotionValueSetText>
                            <Style.MotionInputDataValueTimeFrame
                                // 💡 수정: mode가 1이 아닐 때만 클릭 핸들러가 작동하도록 설정
                                onClick={() => Number(currentLedmode) !== 1 && handleOpenModeOnTimeModal()}
                                style={{ 
                                    opacity: Number(currentLedmode) === 1 ? 0.5 : 1, 
                                    cursor: Number(currentLedmode) === 1 ? "not-allowed" : "pointer" 
                                }}
                            >
                                <Style.MotionInputDataValueTimeText isMenuSelected={groupSettingTab === 4}>
                                    {selectedModeOnTime || "12:00 AM"}
                                </Style.MotionInputDataValueTimeText>
                            </Style.MotionInputDataValueTimeFrame>
                        </Style.MotionValueSetCol>

                        {/* --- Off Time 섹션 --- */}
                        <Style.MotionValueSetCol>
                            <Style.MotionValueSetText
                                isMenuSelected={groupSettingTab === 4}
                                // isDisabled={Number(currentLedmode) === 1}
                            >
                                Off Time
                            </Style.MotionValueSetText>
                            <Style.MotionInputDataValueTimeFrame
                                // 💡 수정: mode가 1이 아닐 때만 클릭 핸들러가 작동하도록 설정
                                onClick={() => Number(currentLedmode) !== 1 && handleOpenModeOffTimeModal()}
                                style={{ 
                                    opacity: Number(currentLedmode) === 1 ? 0.5 : 1, 
                                    cursor: Number(currentLedmode) === 1 ? "not-allowed" : "pointer" 
                                }}
                            >
                                <Style.MotionInputDataValueTimeText isMenuSelected={groupSettingTab === 4}>
                                    {selectedModeOffTime || "12:00 AM"}
                                </Style.MotionInputDataValueTimeText>
                            </Style.MotionInputDataValueTimeFrame>
                        </Style.MotionValueSetCol>
                    </Style.MotionValueSetRow>

                </Style.MotionValueSetFrame>                        

                {/* ✅ 모달 연결 */}
                <TimeModal
                    isOpen={isModeOnTimeModalOpen}
                    onClose={() => setModeOnTimeIsModalOpen(false)}
                    onSave={handleSaveModeOnTime}
                    defaultTime={selectedModeOnTime}
                />
                <TimeModal
                    isOpen={isModeOffTimeModalOpen}
                    onClose={() => setModeOffTimeIsModalOpen(false)}
                    onSave={handleSaveModeOffTime}
                    defaultTime={selectedModeOffTime}
                />

                <Style.CommonMenuConfirm
                    isMenuSelected={groupSettingTab === 4}
                    disabled={groupSettingTab !== 4}
                    onClick={()=> 
                        {
                            setGroupSettingTab(4)
                            openConfirmModal()
                            // handleApply_GroupSets(4)
                        }
                    }
                >
                    적용
                </Style.CommonMenuConfirm>

            </Style.CommonMenuArea>


            <>
            {/* 👇 LED 모드 선택 모달 컴포넌트 렌더링 */}
            {isModeModalOpen && (
                <ModeSelectionModal
                    open={isModeModalOpen}
                    currentMode={currentLedmode}
                    onSelect={handleModeSelect}
                    onClose={closeModeModal}
                />
            )}
            </>

            <>
            {/* 👇 적용 버튼 모달 컴포넌트 렌더링 */}
            {isConfirmModalOpen && (
                <ConfirmButtonModal
                    isOpen={isConfirmModalOpen}
                    tabNum={groupSettingTab}
                    onAction={handleApply_GroupSets}
                    onClose={closeConfirmModal}
                />
            )}
            </>

            </Style.TabGridContainer>
{/* 첫번째 컨테이너 끝 */}

{/* 두번째 컨테이너 시작 */}
            <Style.TabGridContainer2>

            {/* Tab 5 */}
            <Style.MontlyMenuArea
                isMenuSelected={groupSettingTab === 5} // 현재 탭이 1번인지 확인
                onClick={() => setGroupSettingTab(5)} // 클릭 시 1번 탭 활성화
            >

                <Style.CommonMenuTitle>
                    <Style.CommonMenuTitleIcon
                        isMenuSelected={groupSettingTab === 5}
                        $menuUrl={MenuMonthlyIcon}
                        $selectedMenuUrl={MenuMonthlySelectTabletIcon} // 👈 선택된 아이콘 URL 추가
                    >
                    </Style.CommonMenuTitleIcon>
                    <Style.CommonMenuTitleText
                        isMenuSelected={groupSettingTab === 5} // 현재 탭이 1번인지 확인
                    >
                         월별 시간별 밝기 설정
                    </Style.CommonMenuTitleText>
                </Style.CommonMenuTitle>
                
                {/* 월별 탭 (1M ~ 12M) */}
                <Style.MontlyTabScrollFrame>

                    <Style.MontlyTabListFrame>
                        
                        {Array.from({ length: MONTHS }, (_, i) => i + 1).map((month) => { 
                            const isSelected = month === nowMonth; 
                            
                        return(
                            
                            // 🔑 3. isSelected에 따른 조건부 렌더링 적용
                            isSelected ? (
                                // 선택된 상태: Focus 스타일
                                <Style.MontlyTabFrame
                                    key={month}
                                    onClick={() => {
                                        setActiveMonthTab(month);
                                        setnowMonth(month);
                                    }}
                                >
                                    <Style.MontlyTabFocus>
                                    {/* {isSelected && <Style.MontlyTabFocusLine />} */}
                                        <Style.MontlyTabText
                                            isSelected={isSelected} 
                                            isMenuSelected={groupSettingTab === 5}
                                        >
                                            {month}월
                                        </Style.MontlyTabText>
                                    </Style.MontlyTabFocus>
                                    {/* <Style.MontlyTabFocusLine></Style.MontlyTabFocusLine> */}
                                </Style.MontlyTabFrame>    
                            ) : (
                                // 비선택 상태: 기본 스타일
                                <Style.MontlyTabFrame
                                    key={month}
                                    onClick={() => {
                                        setActiveMonthTab(month);
                                        setnowMonth(month);
                                    }}
                                >
                                    <Style.MontlyTabText
                                        isSelected={isSelected} 
                                        isMenuSelected={groupSettingTab === 5}
                                    >
                                        {month}월
                                    </Style.MontlyTabText>
                                </Style.MontlyTabFrame>
                            )
                        )})}
                        
                    </Style.MontlyTabListFrame>

                    <Style.MontlyInputFrame>

                        <Style.MontlyInputDataTitleFrame>
                            <Style.MontlyInputDataTitleLeft
                                isMenuSelected={groupSettingTab === 5}
                            >
                                시간
                            </Style.MontlyInputDataTitleLeft>
                            <Style.MontlyInputDataTitleRight
                                isMenuSelected={groupSettingTab === 5}
                            >
                                밝기
                            </Style.MontlyInputDataTitleRight>
                        </Style.MontlyInputDataTitleFrame>

                        {(monthData[nowMonth - 1] ?? []).map((row, idx) => (
                        <>
                            <Style.MontlyInputDataValueFrame key={idx}>
                                <Style.MontlyInputDataValueTimeFrame
                                    // 💡 수정: 모달에 넘길 기본값 변경
                                    onClick={() =>
                                        openModalForEdit(idx, row.time || "00:00", row.value || 0)
                                    }
                                >
                                    <Style.MontlyInputDataValueTimeText
                                        isMenuSelected={groupSettingTab === 5}
                                    >
                                        {/* 💡 수정: time 값이 0이면 빈 문자열 대신 '00:00' 표시 (시간 포맷 일관성) */}
                                        {row.time || "12:00 AM"}                                             
                                    </Style.MontlyInputDataValueTimeText>
                                </Style.MontlyInputDataValueTimeFrame>

                                <Style.MontlyInputDataValueBright
                                    onClick={() =>
                                        openModalForEdit(idx, row.time || "00:00", row.value || 0)
                                    }                                      
                                    isMenuSelected={groupSettingTab === 5}
                                >

                                    {row.value}
                                    
                                </Style.MontlyInputDataValueBright>


                                {/* 삭제 버튼: 활성화된 슬롯이 1개 초과일 때만 렌더링 (최소 1개 유지) */}
                                {(monthData[nowMonth - 1] ?? []).length > 1 && (
                                    <Style.MontlyInputDataValueDelete
                                        $imgUrl={MenuMonthlyMinusTabletIcon}
                                        onClick={() => removeRow(nowMonth - 1, idx)}
                                    />
                                )}                                    

                            </Style.MontlyInputDataValueFrame>

                            <Style.MontlyInputDataValueLineFrame>
                                <Style.MontlyInputDataValueLine />
                            </Style.MontlyInputDataValueLineFrame>
                        </>
                        ))}

                        <br></br>

                        {(!monthData[nowMonth - 1] || monthData[nowMonth - 1]!.length < MAX_ROWS) && (
                        <Style.MontlyInputDataValueAdd
                            onClick={() => addRow(nowMonth - 1)}
                            >
                            <Style.MontlyInputDataValueAddIcon
                                $imgUrl={MenuMonthlyPlusTabletIcon}
                            />
                            <Style.MontlyInputDataValueAddText>
                                추가
                            </Style.MontlyInputDataValueAddText>                                    
                        </Style.MontlyInputDataValueAdd>
                        )}

                    </Style.MontlyInputFrame>


                {/* ✅ 모달 연결 */}
                <TimeBrightModal
                    isOpen={modalOpen}
                    onClose={() => setModalOpen(false)}
                    onSave={handleModalSave}
                    defaultTime={defaultTime}
                    defaultBrightness={defaultBrightness}
                />


                </Style.MontlyTabScrollFrame>

                <Style.MonthlyConfirm
                    isMenuSelected={groupSettingTab === 5}
                    disabled={groupSettingTab !== 5}
                    onClick={()=> 
                        {
                            setGroupSettingTab(5)
                            openConfirmModal()
                        }
                    }
                >
                    적용
                </Style.MonthlyConfirm>

            </Style.MontlyMenuArea>

                
            </Style.TabGridContainer2>

            </Style.MainTabGridContainer>
            </>
        )}
{/* 2개의 그리드 컨테이너 끝 */}
        </MediaQuery>
        </>


    );
};

export default GroupSettings;
